//#region Util Imports

import * as moment from 'moment'
import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import ArrayStore from 'devextreme/data/array_store'

//#endregion

//#region Service Imports

import { ReferenceTypeService } from '../../../services/reference-type'
import { GridService } from '../../../services/grid'
import { UserSessionService } from '../../../services/user-session'
import { DataTypeFormatService, DataTypeFormatter } from '../../../services/data-type'

//#endregion

import { UserModel, PasswordResetEmailModel, FieldNameValueModel, FormValuesModel, EntityModel, ColumnModel } from '../../api/api.models'
import { CommonHelper } from '../../../helpers/common-helper'
import { Md5 } from './../../../helpers/md5-helper'
import { PopupType } from '../../../helpers/popup-manager'
import { EventsNames } from '../../../helpers/events-names'
import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { i18n } from '../i18n/common.i18n'

import { GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { CommonCreateEdit, CreateEditField, CreateEditSection, CreateEditFieldSettings, BulkEditComparation, BulkEditComparationMode, ExtendedFormItem } from '../common.create-edit'

import { Enums } from '../../../models/common/enums'
import { IReferenceType, IOpObject, IOpData } from '../../../models/util/interfaces'
import { OpDataList } from '../../../models/util/op-data-list'
import { OpDataType } from '../../../models/core/op-data-type'
import { OpDataTypeInGroup } from '../../../models/core/op-data-type-in-group'
import { OpLocation } from '../../../models/core/op-location'
import { OpProfileData, OpView, OpViewColumn } from '../../../models/core'
import { OpValidateInfo } from '../../../models/custom/op-validate-info'

import { Dictionary } from '../../../helpers/dictionary'
import { ReferenceTypeComponent } from '../../../helpers/reference-type-component'
import { OpCoord } from '../../../models/custom/op-map-area'
import { ConfigHelper } from '../../../helpers/config-helper'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { TypeHelper } from '../../../helpers/type-helper'

import { GetReferenceObjectListOptions } from '../../../services/reference-type/reference-type.service'
import { DataProviderListResult } from '../../../data-provider'
import { ChangeStatusSelectItem } from '../change-status/change-status.directive.controller'
import { ConvertHelper } from '../../../helpers/convert-helper'
import { LocationHelper } from '../../../modules/locations/locations.helper'
import { TemplateHelper } from '../../../helpers'

import { DropDownBox } from '../drop-down-box/drop-down-box.interfaces'
import { OperatorSecurityService } from '../../../services/operator'

export interface CreateEditPopupOptions {
	/**
	 * @deprecated Do not use. Use SystemService.openCreateEdit().
	 */
	localStorageVarForSavedEntity?: string
	referenceType: Enums.ReferenceType
	succsessMessage: string
	title: string
	type: PopupType

	onBulkSave: (objectToSave: IOpObject) => ng.IPromise<IOpObject>
	onSave: (objectToSave: IOpObject) => ng.IPromise<IOpObject>

	onSubmit?: (fields: FieldNameValueModel[], id?: number) => ng.IPromise<any> //DO USUNIECIA!!! do zastapienia przez onSave
	submitBulkEdit?: (id: number, fields?: FieldNameValueModel[]) => ng.IPromise<any> //DO USUNIECIA!!! do zastapienia przez onSave

	onBulkSaveFinished?: () => void
	onClose?: () => void
	onHidden?: () => void
	onSectionChanged?: (section: CreateEditSection) => void
}

export interface EditInitParams<TAdditionalParams extends EditInitAdditionaParams = EditInitAdditionaParams> {
	moduleName: Enums.SimaxModuleName
	idReferenceType: Enums.ReferenceType

	groupReferenceType?: Enums.ReferenceType
	groupReferenceValue?: number

	columnsReorderingDisabled?: boolean

	/**
	 * Data types to use instead of the default ones generated based on the given module name.
	 */
	customDataTypes?: {
		paramsToEdit?: Enums.DataType[]
		gridParamsToEdit?: Enums.DataType[]
		paramsRequired?: Enums.DataType[]
	}

	useBusinessObjects: boolean //DO USUNIECIA!!! kiedy pozbędziemy się starych obiektów we wszystkich wywołaniach create edit

	additionalParameters?: TAdditionalParams
	customDataSources?: Dictionary<IReferenceType[]>
	customDataSourcesDefaultValues?: { [key: number]: any }
}

export interface EditInitAdditionaParams { }

export interface CreateEditInitParams<TAdditionalParams extends EditInitAdditionaParams = EditInitAdditionaParams> extends EditInitParams<TAdditionalParams> {
	createEditSelectedTabType: Enums.SimaxCreateEditSelectedTabType
	referenceObjectId: number
	referenceObject?: IReferenceType & IOpObject
	sections: CreateEditSection[]

	referenceObjectRequest?: () => JQueryPromise<IReferenceType & IOpObject>
	dedicatedForm?: string
	isCopy?: boolean
}

export interface BulkEditInitParams<TAdditionalParams extends EditInitAdditionaParams = EditInitAdditionaParams> extends EditInitParams<TAdditionalParams> {
	selectedGridRows: any //TO DO!!! to ma być typowane
	gridColumns: any[] //TO DO!!! to ma być typowane

	section: CreateEditSection
}

interface CreateEditScope extends ng.IScope {
	// popup
	popupOptions: DevExpress.ui.dxPopupOptions
	resetPasswordButtonOptions: DevExpress.ui.dxButtonOptions
	changePasswordButtonOptions: DevExpress.ui.dxButtonOptions
	closeButtonOptions: DevExpress.ui.dxButtonOptions
	popupVisible: boolean
	isUserDetails: boolean
	isLoggedUserDetails: boolean
	userPassword: string
	loggedUser: UserModel
	modelId: number
	tabsOptions: DevExpress.ui.dxTabsOptions
	tabsVisible: boolean
	tabItems: any[]
	panels: CreateEditSection[]
	dateFormat: string
	selectedTab: number
	isLoading: boolean
	noData: boolean

	passwordResetPopupId: number
	distributorChangePopupId: number
	locationDataChangePopupId: string

	toolbarOptions: DevExpress.ui.dxToolbarOptions

	sendEmail: () => void
	options: CreateEditPopupOptions

	// additionalDetailFields
	additionalDetailFieldsInGrid?: boolean

	isLoggedUser: boolean

	openConfirmationPopup()
	confirm()
	confirmNo()
	yes: string
	no: string

	// location type
	getCoords(): any
	onLocationSelected(lat: number, lng: number): void
	onPopoverValueIdSelected(valueId: number, dataTypeId: number, value: string, scriptArg: any, selectedRowData: any): void

	// types / lists
	typeListsNames: string[]

	locationData: {}
	confirmNoChangePrevLocationData: () => void

	bulkGridOptions: GridOptions
	bulkGridData: any
	bulkGridColumns: any
	bulkGrid: DevExpress.ui.dxDataGrid
	colCount: number
	isStoped: boolean
	bulkEditPopupId: any
	startButtonOptions: DevExpress.ui.dxButtonOptions
	stopButtonOptions: DevExpress.ui.dxButtonOptions
	finishButtonOptions: DevExpress.ui.dxButtonOptions
	isStarted: boolean
	hasChanged: boolean
	finishSignal: boolean
	savingProgressOptions: DevExpress.ui.dxProgressBarOptions
	uploadedPercent: number
	actualSavedLocation: number
	customDataSources: Dictionary<IReferenceType[]>
	customDataSourcesDefaultValues: { [key: number]: any }

	saveBulkChanges()
	saveBulkEdit()
	bulkEditWarningId: any
	saveBulkEntities()

	setToFields(fields: any[], locationId: any)
}

export class CreateEditPopupController extends CommonCreateEdit {
	static POPUP_MAX_WIDTH = '800px'

	originalData: CreateEditField[]

	referenceTypeFieldName: string = 'referenceTypeField'
	specificParametersGrid: DevExpress.ui.dxDataGrid
	result: any

	tabs: DevExpress.ui.dxTabs
	entityId: number = null

	gridId: any

	// select boxes and events for distributor
	distributorFormInstance: DevExpress.ui.dxSelectBox
	distributorChangedEvent: any = null
	distributorGridChangedEvent: any = null
	hideDistributorChangePopup: boolean = false

	selectedPopoverData: { valueId: number; dataTypeId: number; value: string }[] = []

	popup: DevExpress.ui.dxPopup
	popupType: PopupType

	isGridUpdate: boolean
	previousSectionState
	submitFailed: boolean = false
	bulkSubmitFailed: boolean = false

	indexEdit = false

	private isClosed: boolean
	private columnsReorderingDisabled: boolean
	private idReferenceType: number
	private dataTypeFormatter: DataTypeFormatter

	//#region dataTypeGroup
	private referenceValueFormInstance: DropDownBox
	private idReferenceFormInstance: DevExpress.ui.dxSelectBox
	//#endregion

	constructor(
		protected $scope: CreateEditScope,
		private $compile: ng.ICompileService,
		protected $q: ng.IQService,
		protected $timeout: ng.ITimeoutService,
		protected api: Api,
		protected localDictionary: LocalDictionaryFactory,
		private dataTypeFormatService: DataTypeFormatService,
		private gridService: GridService,
		protected userSession: UserSessionService,
		protected operatorSecurityService: OperatorSecurityService,
		protected referenceTypeService: ReferenceTypeService
	) {
		super($scope, api, localDictionary, $q, $timeout, userSession, referenceTypeService, operatorSecurityService)

		$scope.isLoading = true

		$scope.passwordResetPopupId = $scope.$id
		$scope.distributorChangePopupId = new Date().getTime()
		$scope.locationDataChangePopupId = new Date().getTime() + 'location'
		$scope.bulkEditPopupId = new Date().getTime() + 'bulkEdit'
		$scope.bulkEditWarningId = new Date().getTime() + 'bulkWarning'
		$scope.loggedUser = api.login.getUser()
		//popup
		$scope.dateFormat = window['simax'].getDateFormat('DATE_FORMAT_DX')
		$scope.popupVisible = false
		$scope.uploadedPercent = 0
		$scope.isStoped = false
		$scope.isStarted = false
		$scope.hasChanged = false
		$scope.actualSavedLocation = 0
		$scope.finishSignal = false

		$scope.popupOptions = {
			bindingOptions: {
				visible: 'popupVisible',
				title: 'options.title',
			},
			fullScreen: false,
			maxWidth: CreateEditPopupController.POPUP_MAX_WIDTH,
			showTitle: true,
			closeOnOutsideClick: false,

			onHiding: (e) => {
				this.closePopup()
			},

			onHidden: () => {
				if (this.$scope.options.onHidden) {
					this.$scope.options.onHidden()
				}
			},

			onInitialized: (e) => {
				this.popup = e.component
			},

			onShowing: (e) => {
				this.previousSectionState = ''
				this.setPopupFullScreen(this.popupType === PopupType.BULK_EDIT_POPUP)
			},
		}

		$scope.startButtonOptions = {
			text: i18n('Popup', 'Start'),
			bindingOptions: {
				disabled: '!hasChanged',
			},
			onClick: () => {
				$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + $scope.bulkEditPopupId, i18n('Popup', 'ConfirmChanges'))
			},
		}

		$scope.stopButtonOptions = {
			text: i18n('Popup', 'Stop'),
			bindingOptions: {
				disabled: '!isStoped',
			},
			onClick: () => {
				this.stopSaving
				$scope.isStarted = false
				$scope.isStoped = false
			},
		}

		$scope.finishButtonOptions = {
			text: i18n('Popup', 'Finish'),
			bindingOptions: {
				// disabled: 'isStarted'
			},
			onClick: this.finishSaving,
		}

		$scope.savingProgressOptions = {
			visible: true,
			statusFormat: (ratio, value) => {
				return i18n('Popup', 'Progress') + ': ' + Math.round(ratio * 100) + '%'
			},
			bindingOptions: {
				value: 'uploadedPercent',
			},
			value: 0,
			min: 0,
			max: 100,
		}

		$scope.saveBulkEntities = () => {
			this.$scope.isStoped = true
			$timeout(() => {
				this.saveEntities()
			})
		}

		$scope.saveBulkChanges = () => {
			this.terminateSaving()
			$timeout(() => {
				this.$scope.isStarted = true
				if (this.idReferenceType == CommonHelper.IdLocation) {
					this.collapsRowsAndRemoveColor()

					this.prepareToValidation().then((formModels: FormValuesModel[]) => {
						LocationHelper.validateLocationsChunked(userSession.getDataProvider(), formModels, LocationHelper.locationFromFormValuesModel)
							.then((validateInfoList: OpValidateInfo[]) => {
								let hasErrors: boolean = false
								let hasWarnings: boolean = false

								validateInfoList.forEach((validateInfo: OpValidateInfo, index: number) => {
									const hasError: boolean = _.contains([Enums.ValidationStatus.Incorrect, Enums.ValidationStatus.Unknown], validateInfo.Status)
									const hasWarning: boolean = validateInfo.Status === Enums.ValidationStatus.Warning

									if (hasError || hasWarning) {
										const message: string = validateInfo.Message.join(TypeHelper.HTMLNewLine)

										this.$scope.bulkGridOptions.dataSource = new DataSource(this.$scope.bulkGridData)
										this.$scope.isStarted = false

										if (hasWarning) {
											hasWarnings = true
											this.$scope.bulkGridData[index].warning = message
										} else if (hasError) {
											hasErrors = true
											this.$scope.bulkGridData[index].error = message
										}

										this.$scope.bulkGrid.expandRow(this.$scope.bulkGridData[index])
									}
								})

								if (hasErrors) {
									CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.WatchErrors), 'error', 5000)
								} else if (hasWarnings) {
									const errorMessages: string[][] = validateInfoList
										.filter((validateInfo: OpValidateInfo) => validateInfo.Status === Enums.ValidationStatus.Warning)
										.map((validateInfo: OpValidateInfo) => validateInfo.Message)

									const errorMsg: string = _.flatten(errorMessages).join(TypeHelper.HTMLNewLine)

									$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + $scope.bulkEditWarningId, errorMsg)
								} else {
									this.saveEntities()
								}
							})
							.fail(() => {
								this.$scope.bulkGridData = this.$scope.bulkGridData.map((data) => {
									data.error = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.UnexpectedError)
									return data
								})
								this.$scope.bulkGridOptions.dataSource = new DataSource(this.$scope.bulkGridData)
								this.$scope.bulkGrid.expandAll(-1)
							})
							.always(() => {
								this.$scope.bulkGrid.refresh()
							})
					})
				} else this.saveEntities()
			})
		}

		$scope.openConfirmationPopup = () => {
			$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + $scope.distributorChangePopupId, i18n('Popup', 'ConfirmDystrybutorChange'))
		}

		$scope.confirm = () => {
			if (this.distributorGridChangedEvent) {
				this.distributorGridChangedEvent.row.data.gridValue = this.getDistributorCaption(this.distributorGridChangedEvent.selectBoxData, this.distributorGridChangedEvent.value)
				this.distributorGridChangedEvent.setValue(this.distributorGridChangedEvent.value)
			}
			this.distributorChangedEvent = null
			this.distributorGridChangedEvent = null
		}
		$scope.confirmNo = () => {
			if (this.distributorChangedEvent) {
				this.distributorFormInstance.option('value', this.distributorChangedEvent.previousValue)
				this.distributorChangedEvent = null
			} else if (this.distributorGridChangedEvent) {
				this.distributorGridChangedEvent.setValue(this.distributorGridChangedEvent.previousValue)
				this.distributorGridChangedEvent = null
			}
		}

		//tabs
		$scope.selectedTab = -1
		$scope.tabItems = []
		$scope.tabsOptions = {
			bindingOptions: {
				visible: 'tabsVisible',
				items: 'tabItems',
				selectedIndex: 'selectedTab',
			},
			onInitialized: (e) => {
				this.tabs = e.component
			},
			onSelectionChanged: (e) => {
				if ($scope.panels && $scope.panels[$scope.selectedTab] && $scope.panels[$scope.selectedTab].grid) {
					$scope.panels[$scope.selectedTab].grid.refresh()
				}

				if (_.isFunction($scope.options.onSectionChanged)) {
					const section: CreateEditSection = $scope.panels != null ? $scope.panels[$scope.selectedTab] : null

					$scope.options.onSectionChanged(section)
				}
			},
		}

		var getLocale = () => {
			var locale = this.userSession.getDataProvider().System.getCurrentLanguage()
			return locale
		}

		$scope.sendEmail = () => {
			var model = new PasswordResetEmailModel()
			api.users
				.getUser($scope.modelId)
				.then((result) => {
					result.fields.forEach((field) => {
						if (field.idDataType == CommonHelper.userColumnLogin) model.user = field.value
					})
				})
				.then((result) => {
					model.locale = getLocale()
					api.password
						.reset(model)
						.then((result) => {
							if (result == 'OK') {
								CommonHelper.openInfoPopup(i18n('Popup', 'ResetEmailSent'))
							} else {
								CommonHelper.openInfoPopup(i18n('Popup', 'ResetError'), 'error')
							}
						})
						.catch(() => {
							CommonHelper.openInfoPopup(i18n('Popup', 'ResetError'), 'error')
						})
				})
		}

		var openChangePassword = () => {
			$scope.$root.$broadcast(EventsNames.OPEN_PASSWORD_CHANGE_POPUP, $scope.loggedUser.id, [
				{
					id: $scope.loggedUser.id,
					name: $scope.loggedUser.username,
				},
			])
		}

		var closeDetails = (clickedCloseButton) => {
			this.isClosed = true

			$scope.popupVisible = false
			$scope.isStarted = false
			$scope.isStoped = false
			if (this.$scope != null && this.$scope.options != null && this.$scope.options.onClose != null && TypeHelper.isFunction(this.$scope.options.onClose)) {
				this.$scope.options.onClose()
			}
		}
		$scope.$on(EventsNames.ESC_KEY_PRESS, () => {
			if ($scope.popupOptions) {
				$timeout(() => {
					closeDetails(null)
				})
			}
		})

		$scope.resetPasswordButtonOptions = {
			text: i18n('Common', 'ResetPassword'),
			onClick: () => {
				$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + $scope.passwordResetPopupId, i18n('Popup', 'ConfirmResetPassword'))
			},
		}

		$scope.changePasswordButtonOptions = {
			text: i18n('Common', 'ChangePassword'),
			onClick: () => {
				openChangePassword()
			},
		}

		$scope.closeButtonOptions = {
			template: TemplateHelper.getIcon(ConfigHelper.Icon.CLOSE, userSession),
			onClick: closeDetails,
		}

		$scope.toolbarOptions = {
			items: [
				{
					location: 'after',
					widget: 'dxButton',
					options: {
						text: i18n('Common', 'Apply'),
						onClick: () => {
							var promises = []
							$scope.panels.forEach((section) => {
								if (section.grid) {
									var deferred = $q.defer()
									section.grid.saveEditData()
									section.grid.refresh().then(() => {
										deferred.resolve()
									})
									promises.push(deferred.promise)
								}
							})
							if (promises.length) {
								$q.all(promises).then(() => {
									$timeout(() => {
										this.submit()
									}, 0)
								})
							} else {
								this.submit()
							}
						},
					},
				},
			],
		}

		// location select callbacks
		$scope.getCoords = () => {
			return this.getCoords()
		}

		$scope.onLocationSelected = (lat: number, lng: number) => {
			this.onLocationSelected(lat, lng)
		}

		$scope.onPopoverValueIdSelected = (valueId: number, datatypeId: number = null, value: string = null, scriptArg: any = null, selectedRowData: any = null) => {
			this.selectedPopoverData = this.selectedPopoverData.filter((item) => {
				return item.dataTypeId != datatypeId
			})
			this.selectedPopoverData.push({ valueId: valueId, dataTypeId: datatypeId, value: value })

			this.onPopoverValueIdSelected(valueId, datatypeId)
		}

		// show popup
		$scope.$on(EventsNames.SHOW_CREATE_EDIT_POPUP, (event, ...args: any[]) => {
			this.indexEdit = false
			this.editedItems = {}

			if (args && args[0] && args[0] !== PopupType.CREATE_EDIT_POPUP) {
				this.popupType = PopupType.BULK_EDIT_POPUP
			} else {
				this.popupType = PopupType.CREATE_EDIT_POPUP
			}

			this.isClosed = false
			$scope.popupVisible = true
			$scope.isLoading = true
			$scope.noData = false
		})

		// initialize panels with forms and grids
		$scope.$on(EventsNames.OPEN_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => {
			if (this.isClosed) {
				$scope.isLoading = false

				return
			}

			this.popup.show().then(() => {
				$scope.popupVisible = true
				$scope.finishSignal = false
				var params: CreateEditInitParams = args[0]
				var sections: CreateEditSection[] = _.clone(params.sections)
				var initialData: CreateEditField[]
				this.idReferenceType = params.idReferenceType
				var selectedTab: number
				var importForm: any
				var useBusinessObjects: boolean = !!params.useBusinessObjects
				var dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)

				if (params != null && params.customDataSources != null) {
					$scope.customDataSources = params.customDataSources
				} else {
					$scope.customDataSources = null
				}

				$scope.customDataSourcesDefaultValues = params.customDataSourcesDefaultValues

				if (useBusinessObjects) {
					var opObject: IOpObject = params.referenceObject

					sections.forEach((section) => {
						section.columns = _.map(section.dataTypesToEdit, (c) => {
							// TODO: sztuczne rzutowanie, trzeba usunac
							var opDataTypeInGroup: OpDataTypeInGroup = <any>c
							dataTypeDict.addOrUpdate(opDataTypeInGroup.idDataType, opDataTypeInGroup.dataType)

							const settings = {
								id: opDataTypeInGroup.idDataType,
								caption: opDataTypeInGroup.toString(),
								referenceTypeId: opDataTypeInGroup.dataType.idReferenceType, // ??
								unitName: opDataTypeInGroup.dataType.unit.name, // usunąć
								type: opDataTypeInGroup.dataType.idDataTypeClass, //??
								format: opDataTypeInGroup.dataType.dataTypeFormat ? opDataTypeInGroup.dataType.dataTypeFormat : {}, //??
								isEditable: opDataTypeInGroup.dataType.isEditable,
							}

							settings['defaultValue'] = opDataTypeInGroup.dataType.defaultValue

							return settings as CreateEditFieldSettings
						})

						section.required = _.map(section.dataTypesRequired, (c) => {
							// TODO: sztuczne rzutowanie, trzeba usunac
							var opDataTypeInGroup: OpDataTypeInGroup = <any>c

							return <CreateEditFieldSettings>{
								id: opDataTypeInGroup.idDataType,
								caption: opDataTypeInGroup.toString(),
								referenceTypeId: opDataTypeInGroup.dataType.idReferenceType, // ??
								unitName: opDataTypeInGroup.dataType.unit.name, // usunąć
								type: opDataTypeInGroup.dataType.idDataTypeClass, //??
								format: opDataTypeInGroup.dataType.dataTypeFormat ? opDataTypeInGroup.dataType.dataTypeFormat : {}, //??
								isEditable: opDataTypeInGroup.dataType.isEditable,
							}
						})
					})

					if (opObject) {
						initialData = opObject.dataList
							.toArray()
							.map((d) => {
								var dataType: OpDataType = dataTypeDict.tryGetValue(d.idDataType)
								if (dataType) {
									return <CreateEditField>{
										id: d.idData,
										idDataType: d.idDataType,
										index: d.indexNBR,
										name: d.idDataType + '',
										value: d.value,
										typeId: dataType ? dataType.idDataTypeClass : 0, // ??
										rowColor: (<any>d).statusColor, //Tylko OpData posiada specyfikację koloru, jeśli to uogólnimy, wtedy należy umieścić
									}
								}
								return null
							})
							.filter((d) => d != null)
					}
					$scope.modelId = params.referenceObject ? params.referenceObject.getReferenceKey() : params.referenceObjectId
					selectedTab = params.createEditSelectedTabType
					$scope.bulkGridData = null
					$scope.bulkGridColumns = null
					this.columnsReorderingDisabled = params.columnsReorderingDisabled
					//importForm = //TO DO!!!
				} else {
					initialData = args[1]
					$scope.modelId = args[2]
					selectedTab = args[3]
					$scope.bulkGridData = _.clone(args[4])
					$scope.bulkGridColumns = args[5]
					this.columnsReorderingDisabled = args[6]
					importForm = args[7]
				}
				this.originalData = _.clone(initialData)

				if ($scope.bulkGridColumns) {
					$scope.bulkGridColumns = $scope.bulkGridColumns.map((column) => {
						column.selectedFilterOperation = column.filterValue = column.filterValues = column.width = undefined
						return column
					})
				}

				if ($scope.bulkGridData && $scope.bulkGridColumns) {
					$scope.colCount = 1
					this.setPopupFullScreen(true)

					const sectionColumns: any[] = []
					let i: number = 0

					sections[0].columns.forEach((sColumn) => {
						$scope.bulkGridColumns.forEach((gColumn) => {
							if (gColumn.caption == sColumn.caption) {
								gColumn.visible = true
								gColumn.visibleIndex = i++
								sectionColumns.push(sColumn)
							}
						})
					})
					sections[0].columns = sectionColumns
				} else {
					$scope.colCount = 3
					this.setPopupFullScreen(false)
				}

				$scope.isLoggedUser = $scope.modelId == $scope.loggedUser.id
				$timeout(() => {
					if (selectedTab) {
						$scope.selectedTab = selectedTab
					} else {
						$scope.selectedTab = 0
					}

					$scope.isLoading = false
				}, 500)

				if (!sections || sections.length == 0) {
					$scope.noData = true
				} else {
					sections.forEach((section: CreateEditSection) => {
						if (section.dataTypesToEdit != null && section.dataTypesToEdit.length === 0) {
							sections.splice(sections.indexOf(section), 1)
						}
					})
				}

				this.entityId = $scope.modelId

				if (!initialData) {
					initialData = []
				}
				this.updateTabs($scope, sections)
				$scope.panels = []

				var mappedData: { [key: number]: CreateEditField } = {}

				initialData.forEach((data) => {
					if (data.index == 0 || importForm) mappedData[data.idDataType || data.id] = data
				})

				const formatIdDataTypes = dataTypeDict.keys().map((idDataType: string) => Number(idDataType))
				this.dataTypeFormatService.getDataTypeFormatter(formatIdDataTypes).then((dataTypeFormatter: DataTypeFormatter) => {
					this.dataTypeFormatter = dataTypeFormatter

					sections.forEach((section: CreateEditSection) => {
						switch (section.type) {
							default:
							case 'form':
								this.createForm(section, mappedData, this.idReferenceType)
								break
							case 'grid':
								this.createGrid(section, initialData)
								this.createAdditionalDetailFieldsSelectBox(section)
								break
							case 'formGrid':
								this.createForm(section, {}, this.idReferenceType)
								this.createFormGrid(section)
								break
							case 'custom':
								break
						}
						$scope.panels.push(section)
					})

					$timeout(() => {
						$scope.$root.$broadcast(EventsNames.UPDATE_COORDINATES_BUTTON_POPUP, $scope.getCoords())
					})
				})
			})
		})

		$scope.$on(EventsNames.OPEN_BULK_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => {
			if (this.isClosed) {
				$scope.isLoading = false

				return
			}

			this.popup.show().then(() => {
				$scope.popupVisible = true
				$scope.isLoading = false
				$scope.finishSignal = false
				var params: BulkEditInitParams = args[0]
				var initialData: CreateEditField[]
				this.idReferenceType = params.idReferenceType
				var selectedTab: number
				var importForm: any

				var dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)
				var section: CreateEditSection = {
					type: params.section.type,
					name: params.section.name,
					columns: params.section.dataTypesToEdit.map((c) => {
						//TO DO: sztuczne rzutowanie, trzeba usunac
						var opDataTypeInGroup: OpDataTypeInGroup = <any>c
						dataTypeDict.addOrUpdate(opDataTypeInGroup.idDataType, opDataTypeInGroup.dataType)

						return <CreateEditFieldSettings>{
							id: opDataTypeInGroup.idDataType,
							caption: opDataTypeInGroup.toString(),
							referenceTypeId: opDataTypeInGroup.dataType.idReferenceType, // ??
							unitName: opDataTypeInGroup.dataType.unit.name, // usunąć
							type: opDataTypeInGroup.dataType.idDataTypeClass, //??
							format: opDataTypeInGroup.dataType.dataTypeFormat ? opDataTypeInGroup.dataType.dataTypeFormat : {}, //??
						}
					}),
					// Czy przypadkiem poniższy wykomentowany kod to nie był efekt copypaste?
					// Z tego co pamiętam w bulk edit nie respektowaliśmy pól oznaczonych jako required
					//needs for disabling reset required fields
					required: params.section.dataTypesRequired.map((c) => {
						//TO DO: sztuczne rzutowanie, trzeba usunac
						var opDataTypeInGroup: OpDataTypeInGroup = <any>c
						return <CreateEditFieldSettings>{
							id: opDataTypeInGroup.idDataType,
							caption: opDataTypeInGroup.toString(),
							referenceTypeId: opDataTypeInGroup.dataType.idReferenceType, // ??
							unitName: opDataTypeInGroup.dataType.unit.name, // usunąć
							type: opDataTypeInGroup.dataType.idDataTypeClass, //??
							format: opDataTypeInGroup.dataType.dataTypeFormat ? opDataTypeInGroup.dataType.dataTypeFormat : {}, //??
						}
					}),
				}

				$scope.bulkGridData = _.clone(params.selectedGridRows) //TO DO!!!
				$scope.bulkGridColumns = params.gridColumns //TO DO!!!
				this.columnsReorderingDisabled = params.columnsReorderingDisabled
				//importForm = args[7]//TO DO!!!

				this.originalData = _.clone(initialData)

				if ($scope.bulkGridColumns) {
					$scope.bulkGridColumns = $scope.bulkGridColumns.map((column) => {
						column.selectedFilterOperation = column.filterValue = column.filterValues = column.width = undefined
						return column
					})
				}

				if ($scope.bulkGridData && $scope.bulkGridColumns) {
					$scope.colCount = 1
					this.setPopupFullScreen(true)

					const sectionColumns: any = []
					let i: number = 0

					section.columns.forEach((sColumn) => {
						$scope.bulkGridColumns.forEach((gColumn) => {
							const gridColumnModel: ColumnModel = this.gridService.getColumnModelFromDxColumn(gColumn)

							if (gridColumnModel != null && gridColumnModel.id === sColumn.id) {
								gColumn.visible = true
								gColumn.visibleIndex = i++
								sectionColumns.push(sColumn)
							}
						})
					})
					section.columns = sectionColumns
				} else {
					$scope.colCount = 3
					this.setPopupFullScreen(false)
				}

				$scope.isLoggedUser = $scope.modelId == $scope.loggedUser.id
				$timeout(() => {
					if (selectedTab) {
						$scope.selectedTab = selectedTab
					} else {
						$scope.selectedTab = 0
					}
				}, 500)

				if (!section) {
					$scope.noData = true
				}

				this.entityId = $scope.modelId

				if (!initialData) {
					initialData = []
				}
				this.updateTabs($scope, [section])
				$scope.panels = []
				const mappedData: { [key: number]: CreateEditField } = {}

				initialData.forEach((data) => {
					if (data.index == 0 || importForm) mappedData[data.idDataType || data.id] = data
				})

				const formatIdDataTypes = dataTypeDict.keys().map((idDataType: string) => Number(idDataType))
				this.dataTypeFormatService.getDataTypeFormatter(formatIdDataTypes).then((dataTypeFormatter: DataTypeFormatter) => {
					this.dataTypeFormatter = dataTypeFormatter

					this.getBulkEditFormInputData(section, this.idReferenceType).then((data: { [idDataType: number]: any }) => {
						for (let item in data) {
							if (item != null && _.isNumber(+item)) {
								mappedData[+item] = {
									id: +item,
									idDataType: +item,
									index: 0,
									name: null,
									rowColor: null,
									typeId: null,
									value: data[item],
								}
							}
						}

						this.createForm(section, mappedData, this.idReferenceType)
						this.createFormGrid(section)
						$scope.panels.push(section)

						$timeout(() => {
							$scope.$root.$broadcast(EventsNames.UPDATE_COORDINATES_BUTTON_POPUP, $scope.getCoords())
						})
					})
				})
			})
		})

		// close
		$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => {
			this.isClosed = true

			var needClosePopup: boolean = args[1]
			if (needClosePopup != false) $scope.popupVisible = false
			this.distributorChangedEvent = null
		})

		//location selected
		$scope.$on(EventsNames.LOCATION_SELECTED_GMAP, (event: ng.IAngularEvent, ...args: any[]) => {
			// TODO Patrz komentarz w evencie poniżej
			var gmapLocationInfo = args[0]

			var city, address, street, nbr, zip, prevCity, prevAddress, prevZip

			if (this.$scope.panels && this.$scope.panels.length > 0) {
				prevCity = this.$scope.panels[0].formData[CommonHelper.locationCity]
				prevAddress = this.$scope.panels[0].formData[CommonHelper.locationAddress]
				prevZip = this.$scope.panels[0].formData[CommonHelper.locationZip]

				gmapLocationInfo[0].address_components.forEach((item) => {
					if (item.types.indexOf('locality') > -1) city = item.long_name
					if (item.types.indexOf('route') > -1) street = item.long_name
					if (item.types.indexOf('street_number') > -1) nbr = item.long_name
					if (item.types.indexOf('postal_code') > -1 && item.types.indexOf('postal_code_prefix') == -1) zip = item.long_name
				})
				address = street ? street : ''
				if (street && nbr) address += ', ' + nbr

				if (!zip || zip.length < 3) {
					gmapLocationInfo.forEach((info) => {
						if (info.types.indexOf('postal_code') > -1 && info.types.indexOf('postal_code_prefix') == -1) {
							info.address_components.forEach((item) => {
								item.types.forEach((type) => {
									if (type == 'postal_code') zip = item.long_name
								})
							})
						}
					})
				}

				this.$scope.panels[0].formData[CommonHelper.locationCity] = city
				this.$scope.panels[0].formData[CommonHelper.locationAddress] = address
				this.$scope.panels[0].formData[CommonHelper.locationZip] = zip

				this.editedItems[CommonHelper.locationCity] = true
				this.editedItems[CommonHelper.locationAddress] = true
				this.editedItems[CommonHelper.locationZip] = true

				if ((prevCity && prevCity != '' && prevCity != city) || (prevAddress && prevAddress != '' && prevAddress != address) || (prevZip && prevZip != '' && prevZip != zip)) {
					var empty = "'" + i18n('Common', 'NoData') + "'"
					var alert = i18n('Popup', 'LocationAddressCompareAlert')
					var question = i18n('Popup', 'LocationAddressChangeQuestion')
					var confirmText = alert + '<br/>'
					if (prevCity != city) confirmText += i18n('Common', 'City') + ': ' + (prevCity ? prevCity : empty) + ' - ' + (city ? city : empty) + '<br/>'
					if (prevAddress != address) confirmText += i18n('Common', 'Address') + ': ' + (prevAddress ? prevAddress : empty) + ' - ' + (address ? address : empty) + '<br/>'
					if (prevZip != zip) confirmText += i18n('Common', 'Zip') + ': ' + (prevZip ? prevZip : empty) + ' - ' + (zip ? zip : empty) + '<br/>'
					confirmText += question
					$scope.locationData = {
						city: prevCity,
						address: prevAddress,
						zip: prevZip,
					}
					$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + $scope.locationDataChangePopupId, confirmText)
				}
			}
		})

		//location-select initialized
		$scope.$on(EventsNames.LOCATION_SELECT_INITIALIZED, (event: ng.IAngularEvent, ...args: any[]) => {
			// TODO Te eventy z mapy powinny być połączone z jakimś id kontrolki, ponieważ w przypadku gdy istnieje już jakaś kontrolka do edycji,
			// np w detailsach to ten event zostanie w niej także uruchomiony.
			if (args && args.length && args.length > 0 && args[0] instanceof OpLocation && this.$scope.panels && this.$scope.panels.length > 0) {
				const loc: OpLocation = <OpLocation>args[0]

				if (this.$scope.panels[0].formData[Enums.DataType.LOCATION_CITY] == null) {
					this.$scope.panels[0].formData[Enums.DataType.LOCATION_CITY] = loc.city
					this.editedItems[Enums.DataType.LOCATION_CITY] = true
				}

				if (this.$scope.panels[0].formData[Enums.DataType.LOCATION_ADDRESS] == null) {
					this.$scope.panels[0].formData[Enums.DataType.LOCATION_ADDRESS] = loc.address
					this.editedItems[Enums.DataType.LOCATION_ADDRESS] = true
				}

				if (this.$scope.panels[0].formData[Enums.DataType.LOCATION_ZIP] == null) {
					this.$scope.panels[0].formData[Enums.DataType.LOCATION_ZIP] = loc.postalCode
					this.editedItems[Enums.DataType.LOCATION_ZIP] = true
				}
			}
		})

		//change previouse location data
		$scope.confirmNoChangePrevLocationData = () => {
			this.$scope.panels[0].formData[CommonHelper.locationCity] = $scope.locationData['city']
			this.$scope.panels[0].formData[CommonHelper.locationAddress] = $scope.locationData['address']
			this.$scope.panels[0].formData[CommonHelper.locationZip] = $scope.locationData['zip']
		}
	}

	createAdditionalDetailFieldsSelectBox(section: CreateEditSection) {
		if (this.$scope.additionalDetailFieldsInGrid) {
			section.additionalDetailFieldsSelectBoxOptions = {
				dataSource: section.columns,
				valueExpr: 'id',
				displayExpr: 'caption',
				placeholder: i18n('Common', 'Select'),
				noDataText: i18n('Common', 'NoData'),
				onSelectionChanged: (e) => {
					section.selectedAdditionalDetailField = e.selectedItem
					if (section.addButton) section.addButton.option('disabled', false)
				},
			}

			section.adding = false
			section.addButtonOptions = {
				disabled: true,
				template: TemplateHelper.getIcon(ConfigHelper.Icon.ADD, this.userSession),
				onClick: () => {
					if (section.grid && !section.adding) {
						var addRow = () => {
							if (this.indexEdit) {
								this.$timeout(() => {
									addRow()
								}, 500)
								return
							}

							section.adding = true
							section.addButton.option('disabled', true)

							var newIndex = 0
							var items = section.grid.option('dataSource')._array

							var allIndexes: number[] = items
								.filter((item) => item.idDataType == section.selectedAdditionalDetailField.id)
								.map((item) => item.index)
								.sort((a, b) => a - b)
							var newIndexFound = allIndexes.some((value, index) => {
								if (value > index) {
									newIndex = index
									return true
								} else if (value == index && index == allIndexes.length - 1) {
									newIndex = allIndexes.length
									return true
								}
								return false
							})

							if (!newIndexFound) {
								var groupIndexes: any = {}
								allIndexes.forEach((value) => {
									if (!groupIndexes[value]) {
										groupIndexes[value] = 1
									} else {
										groupIndexes[value]++
									}
								})
								var lastIndex
								for (lastIndex in groupIndexes);
								if (lastIndex) newIndex = +lastIndex + 1
							}

							var newRow = this.getGridRow(
								0,
								section.selectedAdditionalDetailField.id,
								section.selectedAdditionalDetailField.referenceTypeId,
								newIndex,
								null,
								section.selectedAdditionalDetailField.caption,
								+new Date(),
								allIndexes.length > 0 ? section.selectedAdditionalDetailField.id : 0,
								null,
								section.selectedAdditionalDetailField.type,
								true,
								false,
								section.selectedAdditionalDetailField.unitName
							)

							var insertNewRowPromise = section.grid.option('dataSource').insert(newRow)
							insertNewRowPromise
								.done(() => {
									this.$timeout(() => {
										section.adding = false
										section.addButton.option('disabled', false)
									}, 500)
								})
								.fail((error) => {
									console.log(error)
								})

							if (allIndexes.length > 0) {
								this.updateParentRow(section, items, newIndex, section.selectedAdditionalDetailField.id)
							}

							section.grid.refresh()
						}
						addRow()
					}
				},
				onInitialized: (e) => {
					section.addButton = e.component
				},
			}

			section.removeButtonOptions = {
				disabled: true,
				template: TemplateHelper.getIcon(ConfigHelper.Icon.REMOVE, this.userSession),
				onClick: () => {
					if (section.grid) {
						var store = section.grid.option('dataSource')
						var items = store._array

						section.selectedRows.forEach((row) => {
							if (row.isNew) {
								store.remove(row.rowId)
								if (row.parentId) {
									var parentItem = _.find(items, (it: any) => it.rowId == row.parentId)
									this.updateGridRow(parentItem, items, section)
								}
								if (row.index == 0) {
									this.$scope.panels.forEach((panel) => {
										if (panel != section) {
											if (panel.form && panel.columns.map((c) => c.id).indexOf(row.idDataType) > -1) {
												this.$timeout(() => {
													this.trackChanges(section, row.idDataType, null)
												})
											}
										}
									})
								}
							} else {
								if (section.selectedRows.length == 1 && row.isRemoved) {
									row.isRemoved = false
									section.removeButton.option('template', TemplateHelper.getIcon(ConfigHelper.Icon.REMOVE, this.userSession))
								} else {
									row.isRemoved = true
									if (section.selectedRows.length == 1) section.removeButton.option('template', TemplateHelper.getIcon(ConfigHelper.Icon.REDO, this.userSession))
								}
							}
						})
						section.grid.refresh()
					}
				},
				onInitialized: (e) => {
					section.removeButton = e.component
				},
			}
		}
	}

	updateParentRow(section: CreateEditSection, items, newIndex, rowId, newValue = '') {
		var parentItem = _.find(items, (item: any) => item.rowId == rowId)
		if (!parentItem) {
			var firstItem = _.find(items, (item: any) => item.idDataType == rowId)

			var value = ''
			if (firstItem.gridValue) value = firstItem.gridValue
			else if (firstItem.value) value = firstItem.value

			section.grid.option('dataSource').insert({
				description: firstItem.description,
				index: firstItem.index + ';' + newIndex,
				value: value + ';' + newValue,
				rowId: rowId,
				parentId: 0,
				idDataType: null,
				isGroup: true,
				unitName: firstItem.unitName,
			})

			if (firstItem) {
				firstItem.parentId = rowId
				section.grid.option('dataSource').update(firstItem.id, firstItem)
			}
		} else {
			this.updateGridRow(parentItem, items, section)
		}
	}

	updateGridRow(parentItem, items, section) {
		var store = section.grid.option('dataSource')
		var childItems = _.where(items, { idDataType: parentItem.rowId })

		var valuePromises: ng.IPromise<void>[] = childItems
			.filter((it: any) => it.gridValue && it.gridValue.promise)
			.map((it: any) =>
				it.gridValue.promise.then((value) => {
					it.gridValue = value
				})
			)

		this.$q.all(valuePromises).then(() => {
			parentItem.index = childItems.map((it: any) => it.index).join(';')
			parentItem.value = childItems
				.map((it: any) => {
					var value = it.gridValue ? it.gridValue : it.value
					return CommonHelper.cellFormatForDifferentValues(
						this.userSession,
						{
							value,
							typeId: it.type,
						},
						null,
						it.idDataType,
						this.dataTypeFormatter
					)
				})
				.join(';')

			if (childItems.length == 1) {
				store.remove(parentItem.rowId)
				childItems.forEach((childItem: any) => {
					childItem.parentId = 0
					store.update(childItem.rowId, childItem)
				})
				return
			}

			store.update(parentItem.rowId, parentItem)
		})
	}

	updateTabs($scope: CreateEditScope, sections: any[]) {
		$scope.tabItems = sections.map((section) => {
			return {
				template: (itemData, itemIndex, itemElement) => {
					this.$scope['showSectionError' + itemIndex] = false
					return (
						section.name +
						'<ng-md-icon ng-show="showSectionError' +
						itemIndex +
						'" icon="' +
						window['config']['ICONS']['REQUIRED_TAB'] +
						'" style="fill: #ea4444; vertical-align: middle;" size="20"></ng-md-icon>'
					)
				},
			}
		})
		$scope.tabsVisible = $scope.tabItems.length > 1
	}

	createForm(section: CreateEditSection, data: { [key: number]: CreateEditField }, idReferenceType: number) {
		section.formData = {}
		section.items = []
		section.onFieldChanged = (e: any, idDataType: number = null) => {
			const dataField: string = idDataType || e.element.get(0).attributes['table-id'].nodeValue

			if (dataField) {
				var value = null
				if (e.selectedItem) {
					var number = parseFloat(e.selectedItem.id)
					if (!isNaN(number)) value = number
					else value = e.selectedItem.id
				}

				if (section.formData[dataField] !== value) {
					section.formData[dataField] = value
					this.editedItems[dataField] = true
				}

				if (idReferenceType == Enums.ReferenceType.IdDataTypeGroup) {
					if (+dataField == Enums.DataType.HELPER_ID_REFERENCE_TYPE) {
						this.idReferenceFormInstance.option(<DevExpress.ui.dxSelectBoxOptions>{ searchEnabled: true, showClearButton: true })
						this.onReferenceTypeSelectionChanged(e, section, +dataField)
					}
				}
			}
			if (section.type == 'formGrid' && this.$scope.isLoading == false) {
				let caption: string = null

				if (e.selectedItem != null) {
					caption = e.selectedItem.caption
				}

				if (caption != LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MultipleSelected)) {
					this.bulkEditGridUpdate(this.$scope.bulkGridColumns, section.columns, dataField, caption, this.$scope.bulkGridData)
				}
			}
		}

		section.onDateFieldChanged = (e) => {
			var dataField = e.element.get(0).attributes['table-id'].nodeValue
			this.trackChanges(section, e.element.get(0).attributes['table-id'].nodeValue, e.value)
			if (section.type == 'formGrid') {
				this.bulkEditGridUpdate(this.$scope.bulkGridColumns, section.columns, dataField, e.value, this.$scope.bulkGridData)
			}
		}

		section.onFieldValueChanged = (e) => {
			if (this.$scope.options.type == PopupType.DEVICE_POPUP && !this.hideDistributorChangePopup) {
				if (e.element.get(0).attributes['table-id'].nodeValue == CommonHelper.distributorColumnId) {
					if (e.previousValue != '') {
						if (!this.distributorChangedEvent) {
							this.distributorChangedEvent = e
							this.$scope.openConfirmationPopup()
						}
					}
				}
			}
		}
		section.initializedHandler = (e: any, idDataType?: number) => {
			const dataField: number = idDataType != null ? idDataType : e.element != null ? +e.element.get(0).attributes['table-id'].nodeValue : 0

			if (e.element != null) {
				if (e.element.get(0).attributes['table-id'].nodeValue == CommonHelper.distributorColumnId) {
					this.distributorFormInstance = e.component
				}

				if (e.element.get(0).attributes['table-id'].nodeValue == CommonHelper.issueStatusColumnId || e.element.get(0).attributes['table-id'].nodeValue == CommonHelper.taskStatusColumnId) {
					this.statesFormInstance.resolve(e.component)
				}
			}

			if (idReferenceType == Enums.ReferenceType.IdDataTypeGroup) {
				if (dataField == Enums.DataType.HELPER_REFERENCE_VALUE) {
					this.referenceValueFormInstance = e.component
				}

				if (dataField == Enums.DataType.HELPER_ID_REFERENCE_TYPE) {
					this.idReferenceFormInstance = e.component
				}
			}
		}

		section.onSelectNoteValueChanged = (value: ChangeStatusSelectItem, dataType: Enums.DataType) => {
			if (value != null) {
				$('[table-id=' + dataType + '] .dx-dropdownbox').removeClass('dx-invalid')

				if (section.formData[dataType] != value.value) {
					section.formData[dataType] = value.value
					this.editedItems[dataType] = true
				}

				if (section.type == 'formGrid') {
					this.bulkEditGridUpdate(this.$scope.bulkGridColumns, section.columns, dataType, value.caption, this.$scope.bulkGridData)
				}
			}
		}

		section.onNoteValueChanged = (value: string, dataType: Enums.DataType) => {
			if (value != null) {
				if (section.formData[dataType] != value) {
					section.formData[dataType] = value
					this.editedItems[dataType] = true
				}

				if (section.type == 'formGrid') {
					// zamiast bulkEditGridUpdate bo LOCATION_STATE_TYPE_NOTE nie jest w kolumnach w gridzie

					this.$scope.bulkGridData.forEach((gridObject) => {
						gridObject[dataType] = value
					})
				}
			}
		}

		section.options = null
		this.$timeout(() => {
			section.options = <DevExpress.ui.dxFormOptions>{
				onFieldDataChanged: (e: any) => {
					let oldValue = data[e.dataField] ? data[e.dataField].value : null

					const column: CreateEditFieldSettings = _.find(section.columns, (col: CreateEditFieldSettings) => col.id == e.dataField)
					const typeId: number = data[e.dataField] ? data[e.dataField].typeId : ((column != null) ? column.type : null)

					if (typeId == CommonHelper.datetime || typeId == CommonHelper.date) {
						oldValue = moment(oldValue).toDate()

						if (oldValue != null || e.value == null || oldValue == null || e.value != null || (oldValue != null && e.value != null && oldValue.getTime() != e.value.getTime())) {
							this.editedItems[e.dataField] = true
						} else if (oldValue.getTime() == e.value.getTime()) {
							this.editedItems[e.dataField] = false
						}
					} else {
						if (oldValue == null && e.value == '') {
							this.editedItems[e.dataField] = false
						} else if (oldValue !== e.value) {
							this.editedItems[e.dataField] = true
						} else {
							this.editedItems[e.dataField] = false
						}
					}

					this.trackChanges(section, e.dataField, e.value)
					if (section.type == 'formGrid' && this.editedItems[e.dataField] /*e.value !== '' && e.value !== undefined*/) {
						var refId, isDate
						section.columns.forEach((item) => {
							if (item.id == e.dataField) {
								refId = item.referenceTypeId
								if (item.type == CommonHelper.datetime) isDate = true
							}
						})

						if (!refId && !isDate) {
							this.bulkEditGridUpdate(this.$scope.bulkGridColumns, section.columns, e.dataField, e.value, this.$scope.bulkGridData)
						}

						var popoverChanged = this.selectedPopoverData.filter((item) => {
							return item.dataTypeId == e.dataField
						})
						if (popoverChanged.length > 0) {
							this.bulkEditGridUpdate(this.$scope.bulkGridColumns, section.columns, popoverChanged[0].dataTypeId, popoverChanged[0].value, this.$scope.bulkGridData, popoverChanged[0].valueId)
						}
					}
				},
				requiredMark: '*',
				showRequiredMark: true,
				labelLocation: 'top',
				width: '100%',
				height: '100%',
				scrollingEnabled: true,
				bindingOptions: {
					formData: 'panel.formData',
					items: 'panel.items',
					colCount: 'colCount',
				},
				onInitialized: (e: any) => {
					section.form = e.component

					this.$timeout(() => {
						if (idReferenceType == Enums.ReferenceType.IdDataTypeGroup && _.size(section.columns) > 0) {
							const referenceTypeField: CreateEditField = data[Enums.DataType.HELPER_ID_REFERENCE_TYPE]
							const referenceValueColumn = _.find(section.columns, (column: CreateEditFieldSettings) => column.id == Enums.DataType.HELPER_REFERENCE_VALUE)

							if (referenceTypeField != null && referenceValueColumn != null) {
								referenceValueColumn.referenceTypeId = referenceTypeField.value
							}
						}

						this.loadForm(section, data, this.$scope.options.type, idReferenceType).then(() => {
							if (idReferenceType == Enums.ReferenceType.IdDataTypeGroup) {
								this.$scope.colCount = 1
								this.prepareCustomFormItems(section)
								section.form.option({ items: section.items })
							}
						})
					})
				},
			}
		})
	}

	private selectPopover: { compiledTemplate: JQuery<HTMLElement>; component: any; scrollEvent: () => void } = null
	prepareSelectPopover(component, editorElement, template) {
		var gridCell = angular.element(editorElement).closest('td')
		var grid = gridCell.closest('.dx-treelist-container')

		var compiledTemplate = this.$compile(template)(this.$scope)
		var css = {
			width: gridCell.innerWidth(),
			height: gridCell.innerHeight() + 3,
			left: gridCell.offset().left - grid.offset().left - 2,
			top: gridCell.offset().top - grid.offset().top - 2,
		}
		compiledTemplate.css(css).addClass('dx-treelist-focus-overlay')
		this.selectPopover = {
			compiledTemplate,
			component,
			scrollEvent: () => {
				this.removeSelectPopover()
			},
		}
		grid.append(compiledTemplate)

		this.$timeout(() => {
			const scrollable: any = component.getScrollable()

			if (this.selectPopover != null && scrollable != null) {
				scrollable.on('scroll', this.selectPopover.scrollEvent)
			}

			angular.element(document).click((e) => {
				var target = angular.element(e.target)
				if (
					target.closest(compiledTemplate).length != 0 ||
					target.closest('.location-select-popup').length != 0 ||
					(e.target as any).className == 'dx-page' ||
					(e.target as any).className == 'popup-visible'
				)
					return false
				this.removeSelectPopover()
			})
		})
	}

	setPopupFullScreen(isFullScreen: boolean) {
		if (isFullScreen) {
			this.popup.option({
				maxWidth: '100%',
				fullScreen: true,
			})
		} else {
			this.popup.option({
				maxWidth: CreateEditPopupController.POPUP_MAX_WIDTH,
				fullScreen: false,
			})
		}
	}

	removeSelectPopover() {
		if (this.selectPopover) {
			this.selectPopover.compiledTemplate.remove()
			angular.element(document).unbind('click')
			const scrollable = this.selectPopover.component.getScrollable()

			if (scrollable != null) {
				scrollable.off('scroll', this.selectPopover.scrollEvent)
			}

			this.selectPopover.component.closeEditCell()
			this.selectPopover = null
		}
	}

	closeEditCell(section: CreateEditSection) {
		var grid: DevExpress.ui.dxDataGrid = section.grid
		grid.closeEditCell()
	}

	getDistributorCaption(distributors: any[], id: number) {
		var filteredValues = distributors.filter((it) => it.id == id)
		if (filteredValues.length == 0 || filteredValues.length > 1) {
			console.error('This should not happend')
			return null
		} else {
			return filteredValues[0].caption
		}
	}

	onEditorPreparing(e, section: CreateEditSection) {
		if (e.row && e.index == 2) {
			this.indexEdit = false

			if (e.row.data.type == Enums.DataTypeClass.Datetime) {
				const onDateChange = (dateEvent: any) => {
					if (dateEvent.value) {
						e.setValue(dateEvent.value)
					}
				}

				let initialDateValue = e.row.data.value
				const dateFormat = ConfigHelper.getDateFormat(ConfigHelper.DateFormat.DATE_TIME_FORMAT_MOMENTJS)

				if (_.isString(initialDateValue)) {
					initialDateValue = ConvertHelper.stringToDate(initialDateValue)
				}

				e.cancel = true
				e.editorElement.dxDateBox({
					applyButtonText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Done),
					cancelButtonText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
					type: 'datetime',
					value: initialDateValue,
					width: '100%',

					onFocusOut: onDateChange,
					onValueChanged: onDateChange,
					onEnterKey: onDateChange,

					displayFormat: {
						formatter: (value: Date): string => {
							return value ? moment(value).format(dateFormat) : TypeHelper.emptyString
						},

						parser: (value: string): Date => {
							return value ? moment(value, dateFormat).toDate() : null
						},
					},
				})
			}

			if (e.row.data.type == Enums.DataTypeClass.Boolean) {
				e.cancel = true
				e.editorElement.dxSelectBox({
					displayExpr: 'name',
					placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
					value: e.row.data.value,
					valueExpr: 'value',
					width: '100%',

					dataSource: [
						{
							name: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.False),
							value: false,
						},
						{
							name: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.True),
							value: true,
						},
					],

					onValueChanged: (selectEvent: any) => {
						e.setValue(selectEvent.value)
					},
				})
			}

			if (!e.cancel) {
				if (e.row.data.gridTemplate) {
					this.$scope['onPopoverValueIdSelectedForGrid'] = (valueId: number, datatypeId, name) => {
						this.removeSelectPopover()
						if (valueId) {
							e.setValue(valueId)
							e.row.data.gridValue = name
						} else {
							e.setValue('')
							e.row.data.gridValue = null
						}
						section.grid.option('dataSource').update(e.row.data.rowId, e.row.data)
						this.closeEditCell(section)
					}
					if (e.row.data.gridValue && e.row.data.gridValue.promise) {
						e.row.data.gridValue.promise.then((value) => {
							var template = e.row.data.gridTemplate.replace('[SELECTED_ID]', e.row.data.value).replace('[SELECTED_VALUE]', value)
							this.prepareSelectPopover(e.component, e.editorElement, template)
						})
					} else {
						var template = e.row.data.gridTemplate.replace('[SELECTED_ID]', e.row.data.value).replace('[SELECTED_VALUE]', e.row.data.gridValue)
						this.prepareSelectPopover(e.component, e.editorElement, template)
					}
					e.cancel = true
				} else if (e.row.data.selectBox) {
					this.getSelectBoxOptions(e.row.data.referenceTypeId, e.row.data.idDataType).then((options) => {
						if (options != null) {
							var onValueChanged = (de) => {
								e.setValue(de.value)
								if (de.value) {
									const rows = options.data.filter((d) => d.id == de.value)

									if (rows.length > 0) e.row.data.gridValue = rows[0].caption
								}
								section.grid.option('dataSource').update(e.row.data.rowId, e.row.data)
								this.closeEditCell(section)
							}
							options.options.value = e.row.data.value
							options.options['onFocusOut'] = options.options['onValueChanged'] = options.options['onEnterKey'] = onValueChanged

							e.editorElement.dxSelectBox(options.options)
						}
					})
					e.cancel = true
				}
			}
		} else if (e.row && e.index == 1) {
			this.indexEdit = true
			var lastOnValueChanged = e.editorOptions.onValueChanged
			e.editorOptions.onValueChanged = (onValueChangedEvent: any) => {
				var idDataType = e.row.data.idDataType

				if (section.grid) {
					var items = section.grid.option('dataSource')._array

					if (
						items.some((item) => {
							if (item.idDataType == idDataType) {
								if (item.index == onValueChangedEvent.value) {
									CommonHelper.openInfoPopup(i18n('Popup', 'InvalidIndex'), 'error', 4000)
									return true
								}
							}
							return false
						})
					)
						return
				}

				if (e.row.data.isEdited) {
					if (e.row.data.originalIndex == onValueChangedEvent.value && e.row.data.originalValue == e.row.data.value) e.row.data.isEdited = false
				} else {
					e.row.data.originalIndex = onValueChangedEvent.previousValue
					e.row.data.isEdited = true
				}

				if (onValueChangedEvent.previousValue == 0 || onValueChangedEvent.value == 0) {
					this.$scope.panels.forEach((panel) => {
						if (panel != section) {
							if (panel.form && panel.columns.map((c) => c.id).indexOf(idDataType) > -1) {
								this.$timeout(() => {
									this.isGridUpdate = true
									if (onValueChangedEvent.previousValue == 0) {
										this.trackChanges(section, e.row.data.idDataType, null)
									} else {
										this.trackChanges(section, e.row.data.idDataType, e.row.data.value)
									}
								})
							}
						}
					})
				}
				lastOnValueChanged(onValueChangedEvent)
			}
		}
	}

	getValueFromSelectBoxData(value, selectBoxData) {
		if (angular.isNumber(value)) {
			return this.getValue(value, selectBoxData)
		} else {
			return value
		}
	}

	onCellPrepared(options, section: CreateEditSection) {
		if (options.data && options.column.caption == i18n('Common', 'Value')) {
			if (!options.isEditing) {
				if (options.data.groupValues) {
					this.$q.all(options.data.groupValues).then((values) => {
						let value = values
							.map((val) => {
								return CommonHelper.cellFormatForDifferentValues(
									this.userSession,
									{
										value: val,
										typeId: options.data.groupedTypeId,
									},
									null,
									options.data.idDataType,
									this.dataTypeFormatter
								)
							})
							.join(';')
						options.data.value = value
						options.cellElement.html(value)
						options.data.groupValues = null
					})
				} else if (options.data.gridValue) {
					if (options.data.gridValue.promise) {
						options.data.gridValue.promise.then((value) => {
							options.data.gridValue = value
							options.cellElement.html(value)
						})
					} else {
						options.cellElement.html(options.data.gridValue)
					}
				} else if (options.data.referenceTypeId) {
					if (options.data.value != null) {
						this.referenceTypeService
							.getReferenceObjects(options.data.referenceTypeId, <GetReferenceObjectListOptions>{ referenceValues: [options.data.value] })
							.then((result: DataProviderListResult<IReferenceType>) => {
								if (result != null && _.size(result.objects) > 0) {
									const referenceObj: IReferenceType = _.find(result.objects, (obj: IReferenceType) => obj.getReferenceValue() == options.data.value)

									if (referenceObj != null) {
										options.data.gridValue = referenceObj.toString()
										options.cellElement.html(referenceObj.toString())
									}
								}
							})
						// this.getReferenceTable(options.data.referenceTypeId, options.data.idDataType).then(table => {
						//     table.rows.forEach(r => {
						//         if (r.id == options.data.value) {
						//             options.data.gridValue = r.caption
						//             options.cellElement.html(r.caption)
						//         }
						//     })
						// })
					}
				}
			}
		} else if (options.column.caption == i18n('Common', 'Index') && !options.isEditing) {
			this.indexEdit = false
		}
	}

	createFormGrid = (section) => {
		section.bulkGridOptions = null
		this.$timeout(() => {
			section.bulkGridOptions = this.$scope.bulkGridOptions = {
				name: null,
				type: GridTypes.PAGINATED_SMALL,
				columns: this.$scope.bulkGridColumns,
				dataSource: new DataSource(this.$scope.bulkGridData),
				onInitialized: (e) => {
					this.$scope.bulkGrid = e.component
					this.gridId = e.tableId
					this.$timeout(() => {
						if (this.$scope.bulkGrid) {
							this.$scope.bulkGrid.refresh() //if smth one of that it doesnt refresh properly cations/rows
							this.$scope.bulkGrid.repaint()
						}
					}, 500)
				},
				editing: {
					mode: 'cell',
					allowAdding: false,
					allowUpdating: false,
					allowDeleting: false,
				},
				masterDetail: {
					enabled: true,
					template: function (container, options) {
						container.append($(''))
						var error = options.data.error
						if (error) {
							container.append($('<div ><p>' + error + '</p></div>'))
						}
						var warning = options.data.warning
						if (warning) {
							container.append($('<div ><p>' + warning + '</p></div>'))
						}
					},
					autoExpandAll: false,
				},
				onRowPrepared: (e) => {
					if (e.rowType == 'data') {
						var row = $(e.rowElement)
						if (!e.data.success && !e.data.error && !e.data.warning) {
							e.isExpanded = false
						}
						if (e.data.success) {
							row.css('background-color', '#02E6A1')
							row.children('td').css('background-color', 'inherit')
						} else if (e.data.error) {
							e.isExpanded = true
							row.css('background-color', '#F7484E')
							row.children('td').css('background-color', 'inherit')
						} else if (e.data.warning) {
							e.isExpanded = true
							row.css('background-color', '#FFA500')
							row.children('td').css('background-color', 'inherit')
						}
					}
				},
				addCustomFilters: false,
				buttonsOptions: {
					enabled: true,
				},
				localStorageVarForSavedEntity: 'bulkSaved',
				filterRow: {
					visible: false,
				},
			}
		})
	}

	createGrid(section: CreateEditSection, data: CreateEditField[]): void {
		const items: any[] = this.loadGrid(section, data)

		section.gridOptions = {
			name: 'createEditGrid' + this.$scope.$id,
			type: GridTypes.CREATE_EDIT,
			keyExpr: 'rowId',
			parentIdExpr: 'parentId',
			allowColumnReordering: !this.columnsReorderingDisabled,
			buttonsOptions: {
				enabled: !!section.showDatatypeLegend,
			},
			columns: [
				{
					dataField: 'description',
					caption: i18n('Common', 'Description'),
					allowEditing: false,
				},
				{
					dataField: 'index',
					caption: i18n('Common', 'Index'),
					allowEditing: true,
					dataType: 'string',
				},
				{
					dataField: 'value',
					caption: i18n('Common', 'Value'),
					allowEditing: true,
					calculateCellValue: (rowData: any) => {
						const value = rowData.value
						let idDataTypeClass = rowData.type
						let idDataType = rowData.idDataType

						if (rowData.isGroup) {
							const items = section.grid.option('dataSource')._array
							const allChildItems = _.where(items, { parentId: rowData.rowId })
							const firstChild = _.first<any>(allChildItems)

							if (firstChild != null) {
								idDataType = firstChild.idDataType
								idDataTypeClass = firstChild.type
							}
						}

						return CommonHelper.cellFormatForDifferentValues(
							this.userSession,
							{
								value: value,
								typeId: idDataTypeClass,
							},
							null,
							idDataType,
							this.dataTypeFormatter
						)
					},
				},
				{
					dataField: 'unitName',
					caption: i18n('Common', 'Unit'),
					dataType: 'string',
					allowEditing: false,
				},
			],
			dataSource: new ArrayStore({
				key: 'rowId',
				data: items,
			}),
			editing: {
				allowUpdating: true,
				mode: 'cell',
			},
			onSelectionChanged: (e) => {
				section.selectedRows = e.selectedRowsData
				if (section.removeButton) {
					var isDisabled = e.selectedRowsData.length == 0 || (e.selectedRowsData.length == 1 && e.selectedRowsData[0].isGroup)
					section.removeButton.option('disabled', isDisabled)
					if (!isDisabled) {
						if (e.selectedRowsData.length == 1 && e.selectedRowsData[0].isRemoved) {
							section.removeButton.option('template', TemplateHelper.getIcon(ConfigHelper.Icon.REDO, this.userSession))
						} else {
							section.removeButton.option('template', TemplateHelper.getIcon(ConfigHelper.Icon.REMOVE, this.userSession))
						}
					}
				}
			},
			onInitialized: (e) => {
				section.grid = e.component
			},

			onRowUpdating: (e) => {
				this.removeSelectPopover()
				const editedData = e.newData
				const items = section.grid.option('dataSource')._array
				const item = _.find(items, (it: any) => it.rowId == e.key)

				if (editedData.index) {
					// index edit
					section.grid
						.option('dataSource')
						.update(e.key, item)
						.done(() => {
							this.indexEdit = false
						})
				} else if (editedData.value || editedData.value == '') {
					// value edit
					this.trackChanges(section, item.idDataType, editedData.value, item.index)

					if (item.originalValue == editedData.value && (typeof item.originalIndex == 'undefined' || item.originalIndex == item.index)) {
						item.isEdited = false
					} else {
						item.isEdited = true
					}

					section.grid.option('dataSource').update(e.key, item)
				}

				this.isGridUpdate = false
			},

			onRowUpdated: (e: any) => {
				this.updateParentRows(section, e.data)
			},

			onEditingStart: (e) => {
				var items = section.grid.option('dataSource')._array
				var childItem = _.find(items, (it: any) => it.parentId == e.data.rowId)
				if (childItem) e.cancel = true

				if (e.data && e.data.isRemoved) e.cancel = true
			},
			onEditorPreparing: (e: any) => {
				this.removeSelectPopover()
				this.onEditorPreparing(e, section)
			},
			onCellPrepared: (options: any) => {
				this.onCellPrepared(options, section)
			},
			onRowPrepared: 'edit',
		}

		if (section.showDatatypeLegend) {
			section.gridOptions.showDatatypeLegend = true
		}
	}

	getGridRow(
		id: number,
		idDataType: number,
		referenceTypeId: number,
		index: number,
		value: any,
		description: string,
		rowId: number,
		parentId: number,
		rowColor: any,
		type: number,
		isNew: boolean,
		isRemoved: boolean,
		unitName: string
	) {
		var gridRow = {
			id,
			idDataType,
			referenceTypeId,
			index,
			value,
			description,
			rowId,
			parentId,
			rowColor,
			type,
			isNew,
			isRemoved,
			gridTemplate: null,
			gridValue: <ng.IDeferred<string>>null,
			selectBox: false,
			originalValue: isNew ? null : value,
			unitName,
		}

		var referenceSettings = CommonHelper.getReferenceSettings(this.userSession.getDataProvider(), referenceTypeId, idDataType, this.localDictionary)

		this.referenceTypeService.isViewReferenceType(referenceTypeId).then((hasView: boolean) => {
			// select grid
			if (referenceSettings.isSelectGrid || hasView) {
				gridRow.gridTemplate =
					'<select-popover selected-id="[SELECTED_ID]" selected-value="\'[SELECTED_VALUE]\'" datatype-id="' +
					idDataType +
					'" options="{ referenceTypeId: ' +
					referenceTypeId +
					' }" callback="::onPopoverValueIdSelectedForGrid"></select-popover>'

				gridRow.gridValue = this.$q.defer<string>()

				if (value > 0) {
					this.referenceTypeService.getReferenceObjects(referenceTypeId, <GetReferenceObjectListOptions>{ referenceValues: [value] }).then((result: DataProviderListResult<IReferenceType>) => {
						if (result != null && _.size(result.objects) > 0) {
							const first: IReferenceType = _.first(result.objects)

							if (first != null) {
								gridRow.gridValue.resolve(first.toString())
							} else {
								gridRow.gridValue.resolve(null)
							}
						} else {
							gridRow.gridValue.resolve(null)
						}
					})
				} else gridRow.gridValue.resolve(null)
			}
			// select box
			else if (referenceTypeId) {
				gridRow.selectBox = true
				gridRow.gridValue = this.$q.defer<string>()

				this.getReferenceTable(referenceTypeId, idDataType).then((table) => {
					if (table) {
						var found = table.rows.some((r) => {
							if (r.id == value) {
								gridRow.gridValue.resolve(r.caption)
								return true
							}
							return false
						})
						if (!found) gridRow.gridValue.resolve(value)
					} else {
						gridRow.gridValue.resolve(value)
					}
				})
			}
		})

		return gridRow
	}

	loadGrid(section: CreateEditSection, data: CreateEditField[]): any[] {
		var items = []
		var groupedData = _.groupBy(data, 'idDataType')
		if (groupedData) {
			for (var i in groupedData) {
				var groupedRows = groupedData[i]
				var fieldSettings = _.find(section.columns, (sc) => sc.id === groupedRows[0].idDataType)
				if (groupedRows.length > 1 && fieldSettings) {
					items.push({
						description: fieldSettings.caption,
						index: groupedRows.map((row) => row.index).join(';'),
						value: '',
						rowId: groupedRows[0].idDataType,
						isGroup: true,
						groupValues: [],
						groupedTypeId: groupedRows[0].typeId,
						unitName: fieldSettings.unitName,
					})
				}
			}
		}

		section.columns.forEach((column) => {
			var rowId = +new Date()
			data.forEach((d) => {
				if (d.idDataType == column.id) {
					var newRowId = +new Date()
					while (newRowId == rowId) {
						newRowId = +new Date()
					}
					rowId = newRowId
					var gridRow = this.getGridRow(
						d.id,
						column.id,
						column.referenceTypeId,
						d.index,
						d.value,
						column.caption,
						newRowId,
						groupedData[d.idDataType].length > 1 ? d.idDataType : 0,
						d.rowColor,
						column.type,
						false,
						false,
						column.unitName
					)

					// find group row
					var foundedRows = items.filter((i) => i.rowId == column.id)
					if (foundedRows.length > 1) {
						console.error('This should not happend')
					} else if (foundedRows.length == 1) {
						var groupRow = foundedRows[0]

						if (gridRow.gridValue && gridRow.gridValue.promise) {
							groupRow.groupValues.push(gridRow.gridValue.promise)
						} else {
							groupRow.groupValues.push(gridRow.value)
						}
					}

					items.push(gridRow)
				}
			})
		})
		return items
	}

	trackChanges(section: CreateEditSection, idDataType, value, index = 0) {
		this.$scope.hasChanged = true

		this.$scope.panels.forEach((panel) => {
			if (panel != section) {
				if (panel.form && index == 0 && panel.columns.map((c) => c.id).indexOf(idDataType) > -1) {
					if (idDataType == CommonHelper.distributorColumnId && this.distributorFormInstance) {
						this.hideDistributorChangePopup = true
						this.distributorFormInstance.option('value', value)
						this.hideDistributorChangePopup = false
					}

					if (panel.formData[idDataType] != value) {
						this.editedItems[idDataType] = true
						panel.formData[idDataType] = value
					}
				}
				if (panel.grid && !this.isGridUpdate) {
					var items = panel.grid.option('dataSource')._array
					var founded = items.some((item) => {
						if (item.idDataType == idDataType && item.index == index) {
							item.value = value
							return true
						}
						return false
					})

					// add index with 0 if not exist to grid
					if (!founded && value) {
						panel.columns.some((column) => {
							if (column.id == idDataType) {
								try {
									panel.grid
										.option('dataSource')
										.insert(this.getGridRow(0, column.id, column.referenceTypeId, 0, value, column.caption, +new Date(), 0, null, column.type, true, false, column.unitName))
								} catch (e) {
									console.log(`id: 0, iddatatype: ${column.id}, ref type id: ${column.referenceTypeId} ${e}`)
								}
								panel.grid.refresh()

								return true
							}
							return false
						})
					}

					var allItemsWithSameIdDataType: number[] = items.filter((item) => item.idDataType == idDataType)
					if (allItemsWithSameIdDataType.length > 1) this.updateParentRow(panel, items, index, idDataType, value)
				}
			}
		})
	}

	getId(index: number, idDataType: number) {
		if (this.originalData) {
			var models = this.originalData.filter((d) => d.index == index && d.idDataType == idDataType)
			if (models.length > 0) return models[0].id
		}
		return null
	}

	submit() {
		const sections: any[] = this.$scope.panels

		const isValid: boolean = this.isSectionsValid(sections)

		if (isValid) {
			const unique: { index: number; idDataType: Enums.DataType }[] = []
			const fields: FieldNameValueModel[] = []

			sections.forEach((section) => {
				if (section.form) {
					Object.keys(section.formData).forEach((property) => {
						const idDataType: Enums.DataType = parseInt(property)

						if (
							this.originalData != null &&
							_.isArray(this.originalData) != true && //this var for alarmDef is object! :\
							(section.formData[property] == this.originalData[property] ||
								(section.formData[property] == null && (this.originalData[property] == TypeHelper.emptyString || this.originalData[property] == null)) ||
								(section.formData[property] == TypeHelper.emptyString && (this.originalData[property] == TypeHelper.emptyString || this.originalData[property] == null)))
						) {
							return
						}

						if (unique.filter((o) => o.index == 0 && o.idDataType == idDataType).length == 0) {
							const id: number = this.getId(0, idDataType)
							let state: Enums.OpChangeState = Enums.OpChangeState.New
							let isHelperField: boolean = false
							const dataType: OpDataType = this.userSession.getDataProvider().DataType.getDataTypeLocal(idDataType)

							if (dataType != null) {
								isHelperField = dataType.name.indexOf('HELPER_') == 0
							}

							if (id || isHelperField) {
								if (this.editedItems[idDataType]) {
									state = Enums.OpChangeState.Modified
								} else {
									state = Enums.OpChangeState.Loaded
								}
							} else {
								if (this.editedItems[idDataType] != true) {
									state = Enums.OpChangeState.Loaded
								}
							}

							let nameValue: FieldNameValueModel = new FieldNameValueModel()
							nameValue.idDataType = idDataType
							nameValue.id = id ? id : 0
							nameValue.index = 0
							nameValue.value = section.formData[property]

							if (dataType) {
								nameValue.value = ConvertHelper.prepareDataValue(nameValue.value, dataType)
							}

							nameValue.state = state
							fields.push(nameValue)
							unique.push({ index: 0, idDataType: idDataType })
						}
					})
				}
				if (section.grid) {
					section.grid.option('dataSource')._array.forEach((item) => {
						const idDataType: Enums.DataType = item.idDataType

						if (idDataType) {
							if (unique.filter((o) => o.index == item.index && o.idDataType == idDataType).length == 0) {
								let state: Enums.OpChangeState = Enums.OpChangeState.Loaded
								if (item.isRemoved) {
									state = Enums.OpChangeState.Delete
								} else if (item.isEdited) {
									state = Enums.OpChangeState.Modified
								} else if (item.isNew) {
									state = Enums.OpChangeState.New
								}

								const dataType: OpDataType = this.userSession.getDataProvider().DataType.getDataTypeLocal(idDataType)

								const nameValue: FieldNameValueModel = new FieldNameValueModel()
								nameValue.id = item.id
								nameValue.idDataType = idDataType
								nameValue.state = state
								nameValue.index = item.index
								nameValue.value = item.value

								if (dataType) {
									nameValue.value = ConvertHelper.prepareDataValue(nameValue.value, dataType)
								}

								fields.push(nameValue)
								unique.push({ index: item.index, idDataType: item.idDataType })
							}
						}
					})
				}
			})

			var currentMd5 = Md5.init({ fields, entityId: this.entityId })

			if (this.previousSectionState !== currentMd5 || this.submitFailed) {
				this.$scope.$root.$broadcast(EventsNames.SHOW_LOADING_INDICATOR)
				this.previousSectionState = currentMd5
				if (this.$scope.options.onSubmit) {
					this.$scope.options
						.onSubmit(fields, this.entityId)
						.then((result) => {
							if (!result || (result.hasErrorCode && result.hasErrorCode > 0)) {
								this.submitFailed = true
							} else {
								this.submitFailed = false
							}
						})
						.catch(() => {
							this.submitFailed = true
						})
						.finally(() => {
							this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
						})
				} else {
					//Dostosowaniie starego modelu do obiektu biznesowego
					var objectToSave = <IOpObject>(<any>ReferenceTypeComponent.createReferenceObject(this.idReferenceType, {}))
					objectToSave.idObject = this.entityId
					objectToSave.dataList = new OpDataList<IOpData>()

					fields.forEach((f) => {
						var objectDataToSave = <IOpData>{}
						objectDataToSave.idData = f.id || 0
						objectDataToSave.idDataType = f.idDataType
						objectDataToSave.indexNBR = f.index
						objectDataToSave.value = f.value
						objectDataToSave.opState = f.state
						objectToSave.dataList.push(objectDataToSave)
					})
					objectToSave.opState = objectToSave.idObject == 0 ? Enums.OpChangeState.New : Enums.OpChangeState.Modified

					this.$scope.options
						.onSave(objectToSave)
						.then((result) => {
							if (!result) {
								this.submitFailed = true
							} else {
								this.submitFailed = false
							}
						})
						.catch(() => {
							this.submitFailed = true
						})
						.finally(() => {
							this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
						})
				}
			}
		} else {
			CommonHelper.openInfoPopup(i18n('Common', 'IncorrectData'), 'error', 5000)
			angular.element('.dx-invalid').css('height', '36px')
		}
	}

	getCoords() {
		var latitude
		var longitude
		this.$scope.panels.forEach((panel) => {
			if (!panel.formData) return
			var lat = panel.formData[CommonHelper.locationLatitude]
			var lng = panel.formData[CommonHelper.locationLongitude]
			if (lat && lng) {
				latitude = lat
				longitude = lng
			}
		})
		if (latitude && longitude) {
			let coord = new OpCoord()
			coord.latitude = latitude
			coord.longitude = longitude
			return coord
		}
		return null
	}

	onLocationSelected(lat: number, lng: number) {
		this.$scope.panels.forEach((panel) => {
			if (panel.form && panel.formData) {
				panel.formData[CommonHelper.locationLatitude] = lat
				panel.formData[CommonHelper.locationLongitude] = lng
				this.editedItems[CommonHelper.locationLatitude] = true
				this.editedItems[CommonHelper.locationLongitude] = true
			}
		})
	}

	onPopoverValueIdSelected(valueId: number, datatypeId: number) {
		this.$scope.panels.forEach((panel) => {
			if (panel.form && panel.formData) {
				if (panel.formData[datatypeId] !== undefined || this.popupType === PopupType.BULK_EDIT_POPUP) {
					if (valueId != null) {
						angular
							.element('.data_type_id_' + datatypeId)
							.find('.dx-invalid')
							.removeClass('dx-invalid')
					}

					if (this.popupType === PopupType.BULK_EDIT_POPUP && panel.formData[datatypeId] == valueId && valueId == null) {
						this.$scope.hasChanged = true
						const newValue: string = _.find(this.selectedPopoverData, (item: { valueId: number; dataTypeId: number; value: string }) => valueId == item.valueId && datatypeId == item.dataTypeId).value
						this.bulkEditGridUpdate(this.$scope.bulkGridColumns, panel.columns, datatypeId, newValue, this.$scope.bulkGridData)
					}

					panel.formData[datatypeId] = valueId
					this.editedItems[datatypeId] = true
				}
			} else if (panel.grid) {
			}
		})
	}

	getValue(id: number, table) {
		var result
		table.forEach((data) => {
			if (data.id == id) {
				result = data.caption
			}
		})
		return result
	}

	saveEntities = () => {
		this.submitBulkEdit()
	}

	stopSaving = () => {
		this.$scope.isStarted = false
	}

	finishSaving = () => {
		this.$scope.finishSignal = true
		this.$scope.popupVisible = false
		this.$scope.hasChanged = false
	}

	closePopup = () => {
		if (this.$scope.actualSavedLocation > 0) {
			this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, null, false)
		}

		this.entityId = null
		this.$scope.modelId = null

		this.$scope.bulkGrid = null
		this.$scope.bulkGridOptions = null
		this.$scope.bulkGridColumns = []
		this.$scope.bulkGridData = []
		this.$scope.isStoped = false
		this.$scope.isStarted = false
		this.$scope.hasChanged = false
		this.$scope.actualSavedLocation = 0
		this.$scope.uploadedPercent = 0
		this.$scope.panels = []
		this.selectedPopoverData = []
	}

	terminateSaving() {
		this.$scope.isStoped = true
		this.$scope.isStarted = false
		this.$scope.actualSavedLocation = 0
		this.calculateUpload()
		this.restoreGrid()
		this.$scope.finishSignal = false
	}

	calculateUpload() {
		this.$scope.uploadedPercent = (this.$scope.actualSavedLocation / this.$scope.bulkGridData.length) * 100
	}

	restoreGrid() {
		for (var i = 0; i < this.$scope.bulkGridData.length; i++) {
			this.$scope.bulkGridData[i].success = null
			this.$scope.bulkGridData[i].error = null
		}

		this.$scope.bulkGridOptions.dataSource = new DataSource(this.$scope.bulkGridData)
		this.$scope.bulkGrid.repaint()
		this.$scope.bulkGrid.collapseAll(-1)
	}

	private submitBulkEdit() {
		const sections: CreateEditSection[] = this.$scope.panels
		let dataTypeIds: Enums.DataType[] = []

		if (this.$scope.bulkGridData.length == this.$scope.actualSavedLocation) {
			this.terminateSaving()
		}

		let isValid: boolean = true

		sections.forEach((section: CreateEditSection, index) => {
			this.$scope['showSectionError' + index] = false

			if (section.form) {
				const validationResult: any = section.form.validate()

				if (validationResult != null && !validationResult.isValid) {
					section.showRequiredError = true
					this.$scope['showSectionError' + index] = true
					isValid = false
				}

				dataTypeIds.push(..._.map(section.columns, (column: CreateEditFieldSettings) => column.id))
			}
		})

		dataTypeIds = _.uniq(dataTypeIds)

		if (isValid) {
			const unique = {}
			const fields: FieldNameValueModel[] = []

			if (!this.$scope.actualSavedLocation) {
				this.$scope.actualSavedLocation = 0
			}

			const item: any = this.$scope.bulkGridData[this.$scope.actualSavedLocation]

			this.userSession
				.getDataProvider()
				.DataType.getDataTypes(dataTypeIds)
				.then((dataTypes: OpDataType[]) => {
					sections.forEach((section: CreateEditSection) => {
						const id: Enums.DataType = parseInt(item.id)

						if (!unique[id]) {
							const addedIds: {} = {}
							angular.forEach(section.formData, (value: any, key: string) => {
								if (this.editedItems[key] == true) {
									section.columns.forEach((column: CreateEditFieldSettings) => {
										if (column.id.toString() == key && addedIds[key] != true) {
											const nameValue: FieldNameValueModel = new FieldNameValueModel()
											nameValue.id = 0
											nameValue.nameId = column.id // TODO: NIE UŻYWAĆ W NOWYCH MIEJSCACH - NIE USUWAĆ DOPÓKI NIE PRZESTANIEMY CALKOWICIE KORZYSTAĆ Z CIENKIEGO KLIENTA - UŻYWANE W MASOWEJ EDYCJI LOKALIZACJI
											nameValue.idDataType = column.id
											nameValue.index = !column.index ? 0 : column.index
											nameValue.value = value
											nameValue.state = !column || !column.opState ? Enums.OpChangeState.Loaded : column.opState

											const dataType: OpDataType = _.find(dataTypes, (dt: OpDataType) => dt.idDataType == column.id)

											if (dataType != null) {
												let format: string = undefined

												if (
													this.dataTypeFormatter != null &&
													(dataType.idDataTypeClass === Enums.DataTypeClass.Datetime || dataType.idDataTypeClass === Enums.DataTypeClass.Time || dataType.idDataTypeClass === Enums.DataTypeClass.Date)
												) {
													format = this.dataTypeFormatter.getDateFormat(ConfigHelper.DateFormat.DATE_TIME_FORMAT_MOMENTJS, dataType.idDataType)
												}

												nameValue.value = ConvertHelper.prepareDataValue(nameValue.value, dataType, format)
											}

											fields.push(nameValue)
											addedIds[key] = true
										}
									})
								}
							})

							unique[id] = true
						}
					})

					// Specjalna obsluga pól z notatkami
					if (sections[0] && sections[0].formData) {
						angular.forEach(sections[0].formData, (value, key) => {
							this.CHANGE_STATUS_ID_DATA_TYPES.forEach((idDataTypes: [Enums.DataType, Enums.DataType]) => {
								if (+key === idDataTypes[1]) {
									const nameValue = new FieldNameValueModel()

									nameValue.id = 0
									nameValue.nameId = idDataTypes[1]
									nameValue.value = value

									fields.push(nameValue)
								}
							})
						})
					}

					const formModel: FormValuesModel = new FormValuesModel()
					formModel.id = null
					formModel.fields = fields

					this.saveBulkEdit(formModel)
				})
		}
	}

	saveBulkEdit(formModel: FormValuesModel) {
		if (!this.$scope.finishSignal) {
			if (this.$scope.isStarted) {
				if (!this.$scope.actualSavedLocation) this.$scope.actualSavedLocation = 0
				if (this.$scope.bulkGridData.length > this.$scope.actualSavedLocation) {
					var id = this.$scope.bulkGridData[this.$scope.actualSavedLocation].id
					this.setToFields(formModel.fields, id)
					this.saveSingleObject(id, formModel)
				} else {
					this.$scope.isStarted = false
				}
			}
		} else {
			this.terminateSaving()
		}
	}

	//TO DO!!! Czy ta metoda w ogole ma sens?
	setToFields(fields: any[], locationId: any) {
		for (var i = 0; i < fields.length; i++) {
			if (fields[i].idDataType == Enums.DataType.HELPER_ID_LOCATION) {
				fields[i].value = locationId
			}
		}
	}

	saveSingleObject(objectId: number, form: FormValuesModel) {
		var currentMd5 = Md5.init({ objectId, fields: form.fields })
		if (this.previousSectionState !== currentMd5 || this.bulkSubmitFailed) {
			this.previousSectionState = currentMd5
			if (this.$scope.options.submitBulkEdit) {
				return this.$scope.options
					.submitBulkEdit(objectId, form.fields)
					.then((obj) => {
						this.previousSectionState = this.$scope.panels

						if (!obj) {
							this.bulkSubmitFailed = true
							this.$scope.bulkGridData[this.$scope.actualSavedLocation].error = i18n('Common', 'WebServiceException')
							this.$scope.bulkGridOptions.dataSource = new DataSource(this.$scope.bulkGridData)
							this.$scope.bulkGrid.refresh()
						} else {
							if (obj.hasErrorCode && obj.hasErrorCode > 0) {
								this.bulkSubmitFailed = true
								this.$scope.bulkGridData[this.$scope.actualSavedLocation].error = CommonHelper.getErrorMessage(obj.hasErrorCode, obj.errorMessage)
								this.$scope.bulkGridOptions.dataSource = new DataSource(this.$scope.bulkGridData)
								this.$scope.bulkGrid.refresh()
							} else {
								this.bulkSubmitFailed = false
								this.$scope.bulkGridData[this.$scope.actualSavedLocation].success = 'success'
								this.$scope.bulkGridOptions.dataSource = new DataSource(this.$scope.bulkGridData)
								this.$scope.bulkGrid.refresh()
								CommonHelper.setValueToLocalStorage(this.$scope.options.localStorageVarForSavedEntity, true, 0)
								CommonHelper.openInfoPopup(this.$scope.options.succsessMessage)
							}
						}
						this.$scope.actualSavedLocation++
						this.calculateUpload()
						if (this.$scope.bulkGridData.length > this.$scope.actualSavedLocation) {
							this.submitBulkEdit()
						} else {
							this.$scope.isStarted = false
							this.restoreCssFontClass()
						}
					})
					.catch((err) => {
						this.bulkSubmitFailed = true
						console.log(err)
					})
			} else {
				//Dostosowaniie starego modelu do obiektu biznesowego
				var objectToSave = <IOpObject>{}
				objectToSave.idObject = !this.entityId ? objectId : this.entityId
				objectToSave.dataList = new OpDataList<IOpData>()
				form.fields.forEach((f) => {
					var objectDataToSave = <IOpData>{}
					objectDataToSave.idDataType = f.idDataType
					objectDataToSave.indexNBR = !f.index ? 0 : f.index
					objectDataToSave.value = f.value
					objectDataToSave.opState = f.state
					objectToSave.dataList.push(objectDataToSave)
				})
				return this.$scope.options
					.onBulkSave(objectToSave)
					.then((obj) => {
						this.previousSectionState = this.$scope.panels

						if (!obj) {
							this.bulkSubmitFailed = true
							this.$scope.bulkGridData[this.$scope.actualSavedLocation].error = i18n('Common', 'WebServiceException')
							this.$scope.bulkGridOptions.dataSource = new DataSource(this.$scope.bulkGridData)
							this.$scope.bulkGrid.refresh()
						} else {
							this.bulkSubmitFailed = false
							this.$scope.bulkGridData[this.$scope.actualSavedLocation].success = 'success'
							this.$scope.bulkGridOptions.dataSource = new DataSource(this.$scope.bulkGridData)
							this.$scope.bulkGrid.refresh()
							CommonHelper.setValueToLocalStorage(this.$scope.options.localStorageVarForSavedEntity, true, 0)
							CommonHelper.openInfoPopup(this.$scope.options.succsessMessage)
						}
						this.$scope.actualSavedLocation++
						this.calculateUpload()
						if (this.$scope.bulkGridData.length > this.$scope.actualSavedLocation) {
							this.submitBulkEdit()
						} else {
							this.$scope.isStarted = false
							this.finishBulkEdit()
							this.restoreCssFontClass()
						}
					})
					.catch((err) => {
						this.bulkSubmitFailed = true
						console.log(err)
						this.$scope.bulkGridData[this.$scope.actualSavedLocation].error = err
						this.$scope.bulkGridOptions.dataSource = new DataSource(this.$scope.bulkGridData)
						this.$scope.bulkGrid.refresh()
						this.finishBulkEdit()
					})
			}
		}
	}

	private finishBulkEdit() {
		if (this.$scope.options.onBulkSaveFinished != null) {
			this.$scope.options.onBulkSaveFinished()
		}
	}

	private restoreCssFontClass(): void {
		const columns: any[] = this.$scope.bulkGridColumns ? this.$scope.bulkGridColumns : []
		columns.forEach((column: any) => {
			if (column.opState === Enums.OpChangeState.Modified) {
				column.cssClass = null
			}
		})
		this.$scope.bulkGrid.option('columns', columns)
	}

	bulkEditGridUpdate(columns, sectionColumns, columnToEdit, newValue, gridData, referenceValue: number = null) {
		sectionColumns.forEach((sColumn) => {
			if (sColumn.id == columnToEdit) {
				columns.forEach((column) => {
					const gridColumnModel: ColumnModel = this.gridService.getColumnModelFromDxColumn(column)

					if (gridColumnModel != null && gridColumnModel.id === sColumn.id) {
						sColumn.opState = Enums.OpChangeState.Modified
						column.cssClass = 'columnEditing'
						column.referenceValue = referenceValue
						column.opState = Enums.OpChangeState.Modified
						gridData.forEach((gridObject) => {
							gridObject[column.dataField] = newValue
						})
					}
				})
			}
		})

		if (this.$scope.bulkGrid) {
			this.$scope.bulkGrid.beginUpdate()
			this.$scope.bulkGrid.option({
				columns: columns,
				dataSource: new DataSource(gridData),
			})
			this.$scope.bulkGrid.endUpdate()
		}
	}

	prepareToValidation() {
		var deferred = this.$q.defer()
		var sections: any[] = this.$scope.panels
		var formModels: any[] = []
		var actualLocation: number = 0
		var bulkGridData: any[] = this.$scope.bulkGridData
		var promisedFormModels: any[] = []

		//if (this.$scope.bulkGridData.length == this.$scope.actualSavedLocation) {
		//    this.terminateSaving()
		//}
		bulkGridData.forEach((bulkGridRow) => {
			const isValid: boolean = true
			//sections.forEach((section, index) => {
			//    this.$scope['showSectionError' + index] = false
			//    if (section.form && !section.form.validate().isValid) {
			//        section.showRequiredError = true
			//        this.$scope['showSectionError' + index] = true
			//        isValid = false
			//    }
			//    return true
			//})

			if (isValid) {
				const unique = {}
				const fields: FieldNameValueModel[] = []

				if (!actualLocation) {
					actualLocation = 0
				}
				const item = this.$scope.bulkGridData[actualLocation]

				const promisedValues = []
				sections.forEach((section) => {
					const id: number = parseInt(item.id)
					if (!unique[id]) {
						angular.forEach(section.formData, (value, key) => {
							section.columns.forEach((column) => {
								if (column.id == key) {
									section.bulkGridOptions.columns.forEach((gColumn) => {
										const gridColumnModel: ColumnModel = this.gridService.getColumnModelFromDxColumn(gColumn)

										if (gridColumnModel != null && gridColumnModel.id === column.id) {
											if (gColumn.referenceValue) {
												var nameValue = new FieldNameValueModel()
												nameValue.nameId = column.id // TODO: NIE UŻYWAĆ W NOWYCH MIEJSCACH - NIE USUWAĆ DOPÓKI NIE PRZESTANIEMY CALKOWICIE KORZYSTAĆ Z CIENKIEGO KLIENTA - UŻYWANE W MASOWEJ EDYCJI LOKALIZACJI
												nameValue.idDataType = column.id
												nameValue.index = !column.index ? 0 : column.index
												nameValue.value = gColumn.referenceValue
												fields.push(nameValue)
											} else if (column.referenceTypeId != null && column.id != CommonHelper.meterColumnId) {
												promisedValues.push({ promised: this.localDictionary.getReferenceTable(column.referenceTypeId, column.id), columnId: column.id, dataField: item[gColumn.dataField] })
											} else {
												var nameValue = new FieldNameValueModel()
												nameValue.nameId = column.id // TODO: NIE UŻYWAĆ W NOWYCH MIEJSCACH - NIE USUWAĆ DOPÓKI NIE PRZESTANIEMY CALKOWICIE KORZYSTAĆ Z CIENKIEGO KLIENTA - UŻYWANE W MASOWEJ EDYCJI LOKALIZACJI
												nameValue.idDataType = column.id
												nameValue.index = !column.index ? 0 : column.index
												nameValue.value = item[gColumn.dataField]
												fields.push(nameValue)
											}
										}
									})
								}
							})
						})
						unique[id] = true
					}
				})

				var formModel = new FormValuesModel()
				formModel.id = bulkGridRow.id
				formModel.fields = fields

				if (promisedValues.length == 0) {
					//formModels.push(formModel)
					promisedFormModels.push(this.promisedFormModel(formModel))
				} else {
					var promises = []
					promisedValues.forEach((item) => {
						promises.push(item.promised)
					})

					promisedFormModels.push(
						this.$q
							.all(promises)
							.then((tables: any[]) => {
								tables.forEach((table, index) => {
									var nameValue = new FieldNameValueModel()
									nameValue.nameId = promisedValues[index].columnId // TODO: NIE UŻYWAĆ W NOWYCH MIEJSCACH - NIE USUWAĆ DOPÓKI NIE PRZESTANIEMY CALKOWICIE KORZYSTAĆ Z CIENKIEGO KLIENTA - UŻYWANE W MASOWEJ EDYCJI LOKALIZACJI
									nameValue.idDataType = promisedValues[index].columnId
									if (table.selectBoxData)
										table.selectBoxData.forEach((item) => {
											if (item.caption == promisedValues[index].dataField) nameValue.value = item.id
										})
									else {
										this.selectedPopoverData.forEach((item) => {
											if (item.dataTypeId == promisedValues[index].columnId) nameValue.value = item.valueId
										})
									}
									fields.push(nameValue)
								})
							})
							.then(() => {
								formModel.id = bulkGridRow.id
								formModel.fields = fields.filter((f) => f.value)
								//formModels.push(formModel)
								return formModel
							})
					)
				}
			}
			actualLocation++
		})

		if (promisedFormModels.length) {
			this.$q.all(promisedFormModels).then((formModels) => {
				deferred.resolve(formModels)
			})
		}

		return deferred.promise
	}

	promisedFormModel(formModel: FormValuesModel) {
		var deferred = this.$q.defer()
		deferred.resolve(formModel)
		return deferred.promise
	}

	collapsRowsAndRemoveColor() {
		this.$scope.bulkGrid.collapseAll(-1)
		this.$scope.bulkGridData.forEach((data, index) => {
			this.$scope.bulkGridData[index].error = null
			this.$scope.bulkGridData[index].success = null
			this.$scope.bulkGridData[index].warning = null
		})
		this.$scope.bulkGridOptions.dataSource = new DataSource(this.$scope.bulkGridData)
		this.$scope.bulkGrid.repaint()
		this.$scope.bulkGrid.refresh()
	}

	//#region Tree Edit

	private updateParentRows(section: CreateEditSection, item: any): void {
		$.when(this.updateParentValue(section, item), this.updateParentIndex(section, item)).then(() => {
			section.grid.refresh()
		})
	}

	private updateParentValue(section: CreateEditSection, item: any): void {
		const parentItem = this.getParentItem(section, item)

		if (parentItem != null) {
			const allChildItems = this.getChildItems(section, parentItem)

			if (allChildItems != null) {
				parentItem.value = _.map(allChildItems, (childItem: any) => {
					const value = childItem.gridValue ? childItem.gridValue : childItem.value

					return CommonHelper.cellFormatForDifferentValues(
						this.userSession,
						{
							value,
							typeId: childItem.type,
						},
						null,
						childItem.idDataType,
						this.dataTypeFormatter
					)
				}).join(';')

				return section.grid.option('dataSource').update(parentItem.rowId, parentItem)
			}
		}
	}

	private updateParentIndex(section: CreateEditSection, item: any): void {
		const parentItem = this.getParentItem(section, item)

		if (parentItem != null) {
			const allChildItems = this.getChildItems(section, parentItem)

			if (allChildItems != null) {
				parentItem.index = _.map(allChildItems, (childItem: any) => childItem.index).join(';')

				return section.grid.option('dataSource').update(parentItem.rowId, parentItem)
			}
		}
	}

	private getParentItem(section: CreateEditSection, item: any): any {
		const treeItems = this.getTreeItems(section)

		return _.find(treeItems, (it: any) => it.rowId == item.parentId)
	}

	private getTreeItems(section: CreateEditSection): any[] {
		if (section != null && section.grid != null) {
			return section.grid.option('dataSource')._array
		}

		return []
	}

	private getChildItems(section: CreateEditSection, parentItem: any): any {
		const treeItems = this.getTreeItems(section)

		return _.where(treeItems, { parentId: parentItem.rowId })
	}

	//#endregion

	//#region bulk edit form input data

	private getBulkEditFormInputData(section: CreateEditSection, idReferenceType: number): JQueryPromise<{ [idDataType: number]: any }> {
		const promises: JQueryPromise<void>[] = []
		const formData: { [idDataType: number]: any } = {}

		for (let i: number = 0; i < section.columns.length; ++i) {
			const column: CreateEditFieldSettings = section.columns[i]
			const referenceSettings: { settings?: { dictionaryMethod: string }; isSelectGrid: boolean } = CommonHelper.getReferenceSettings(
				this.userSession.getDataProvider(),
				column.referenceTypeId,
				column.id,
				this.localDictionary,
				idReferenceType
			)

			// set values
			formData[column.id] = null

			const comparationResult: BulkEditComparation = this.getBulkGridColumnDataComparation(column.id, section)
			if (comparationResult.comparation === BulkEditComparationMode.Single) {
				if (column.referenceTypeId != null && !referenceSettings.isSelectGrid) {
					const idDataType: number = column.id
					const deferred: JQueryDeferred<void> = $.Deferred<void>()
					this.getReferenceTable(column.referenceTypeId, column.id).then((table: { rows: ColumnModel[]; referenceTableName: string }) => {
						const itemToSelect: ColumnModel = _.find(table.rows, (data: ColumnModel) => data.caption === comparationResult.selectedValue)

						if (itemToSelect != null) {
							formData[idDataType] = itemToSelect.id
						}
						deferred.resolve()
					})
					promises.push(deferred.promise())
				} else {
					formData[column.id] = comparationResult.selectedValue
				}
			} else if (comparationResult.comparation === BulkEditComparationMode.Multiple) {
				if (column.referenceTypeId != null) {
					formData[column.id] = comparationResult.selectedId
				} else {
					if (column.type != Enums.DataTypeClass.Date && column.type != Enums.DataTypeClass.Datetime && column.type != Enums.DataTypeClass.Time) {
						formData[column.id] = comparationResult.selectedValue
					}
				}
			}
		}

		return $.when(...promises).then(() => {
			return formData
		})
	}

	//#endregion

	//#region dataTypeGroupEdit

	private prepareCustomFormItems(section: CreateEditSection): void {
		const formSection: CreateEditSection = _.find(this.$scope.panels, (section: CreateEditSection) => section.type === 'form')

		if (formSection != null && formSection.formData != null) {
			this.prepareControllForAllowedDataTypeGroups(formSection)
		}
	}

	private prepareControllForAllowedDataTypeGroups(section: CreateEditSection): void {
		const allowedDataTypeGroups: OpProfileData[] =
			this.userSession.getLoggedOperator().profile != null && this.userSession.getLoggedOperator().profile.parameters != null
				? _.filter(this.userSession.getLoggedOperator().profile.parameters.toArray(), (data: OpProfileData) => data.idDataType == Enums.DataType.PROFILE_ALLOWED_DATA_TYPE_GROUP)
				: null

		if (_.size(allowedDataTypeGroups) > 0) {
			const nameValueControl: ExtendedFormItem = _.find(section.items, (item: ExtendedFormItem) => {
				return +item.dataField == Enums.DataType.HELPER_NAME
			})

			if (nameValueControl != null) {
				this.$scope[`referenceTable${Enums.DataType.HELPER_NAME}`] = _.map(allowedDataTypeGroups, (group: OpProfileData) => {
					return {
						id: group.value,
						caption: group.value,
					}
				})
				nameValueControl.template = super.getDefaultSelectBoxTemplate(Enums.DataType.HELPER_NAME, `referenceTable${Enums.DataType.HELPER_NAME}`, false, section)
			}
		}
	}

	private onReferenceTypeSelectionChanged(e: any, section: CreateEditSection, idDataType: Enums.DataType): void {
		const column: CreateEditFieldSettings = _.find(section.columns, (column: CreateEditFieldSettings) => +column.id == idDataType)

		if (idDataType == Enums.DataType.HELPER_ID_REFERENCE_TYPE) {
			if (this.referenceValueFormInstance != null) {
				this.referenceValueFormInstance.changeReferenceType(e.selectedItem != null ? e.selectedItem.id : null)
			}
		}
	}

	//#endregion
}
